import React, {Component} from "react";
import {Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import trophy from '../../assets/img/trophy-cup.svg';
import ConfirmationModal from '../Dashboard/DashboardUser/ConfirmationModal';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import ReactHighcharts from 'react-highcharts';
import PieChart from 'react-minimal-pie-chart';
import userImage from '../../assets/img/128x128.jpg';
import api from '../../utils/api';
import jwt from 'jsonwebtoken';
import send from '../../utils/ChatServer.js';
import DatePicker from 'react-datepicker';
import {Link} from 'react-router-dom';
import jQuery from 'jquery';
import bootbox from 'bootbox';
import Select from 'react-select';
import {SortableContainer, SortableElement, arrayMove} from "react-sortable-hoc";
import { throws } from "assert";

const $ = window && window.jQuery ? window.jQuery : jQuery;


const subjectColors = ["#ada7fc", "#ed6e86", "#ffde74"];

// Sortable subject order:
const SortableItem = SortableElement(({ item}) =>  (
    <div className="panel customPanel no-margin">
        <div className="panel-heading border-bottom bg-black">
            <div className="panel-control">
                <a href="#AddStrategyModal" data-toggle="modal" className="btn btn-info"><i className="zmdi zmdi-plus-circle"></i> </a>
            </div>
            <h3 className="panel-title font-400"><span className="font-16"><a href="#collapse_1" data-toggle="collapse" className="text-white"> <i className="zmdi zmdi-library"></i> {item.name}</a></span></h3>
        </div>
    </div>
    ));

const SortableList = SortableContainer(({subjects, course}) =>  (
        <div

            className="panel-body no-padding"

        >
            {subjects && course.CourseSubject ?
                subjects.filter(item => course.CourseSubject.filter(s => s.id === item).length > 0).map((item, index) => {
                    let subject = course.CourseSubject.filter(s => s.id === item)[0];
                    
                    return (
                        <SortableItem
                            key={`item-${index}`}
                            item={subject}
                            index={index}
                        />
                    )
                })
            : null
                
            }
        </div>
    )
);

class StudentProgress extends Component {

    constructor(props){
        super(props);

        this.state = {
            settingSubjectName: '',
            settingSubjectId: '',
            confirmTestDateModal: false,
            testDateConfirmed: false,
            testDate: '',
            confirmSubjectDateModal: false,
            subjectDate: '',
            subjectDateConfirmed: '',
            view: '',
            viewLoaded: false,
            progressView: '',
            progressViewLoaded: false,
            progressChart: [],
            progressChartX: [],
            currentSubject: null,
            attendanceType: 'graph',
            chart: [],
            chartX: [],
            chartType: 'bar',
            completionPercent: null,
            attentivePercent: null,
            attendanceHours: [],
            improvement: {
                attendance: null,
                attentiveness: null,
                efficiency: null,
                quiz: null
            },
            studiedLastMonth: null,
            studiedThisWeek: null,
            attentiveThisWeek: null,
            unitsThisWeek: null,
            quizScoreThisWeek: null,
            efficiencyThisWeek: null,
            recommendationsThisWeek: null,
            studiedTotal: null,
            studiedAverage: null,
            canResetTestDate: true,
            timeTaken: -1,
            requiredPerDay: -1,
            timeLeft: -1,
            timerId: null,
            estimatedTime: -1,
            estimatedTimeClass: '',
            subjectMonth: new Date().getMonth(),
            timeToTest: -1,
            sendNotification: {subjectId: '', content: '', mine: true, courseId: this.props.match.params.courseId, profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0] ? this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId : '', sender: ''},
            sendReminder: {subjectId: '', lectures: [], tests: [], courseUserId: '', profileId: ''},
            task: {title: '', assigned: true, date: new Date(), value: [], progress: 0, currentIndex: 0, profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0] ? this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId : '', courseId: this.props.match.params.courseId, courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0] ? this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id : ''},
            subject: '',
            courseStatus: {type: 'active', start: '', end: ''},
            flag: {flag_id: 27, content: '', type: 'red'},
            subjectOrder: [],
            deadline: moment(),
            calendarMode: 'attendance',
            calendarSet: false,
            cu: null,
            results: {},
            ul: {},
            test: {}
        }

        this.timerId = null;
    }
    
    setSubjectOrder = () => {
        let command = {
            type: 'SET_SUBJECT_ORDER',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            subjectOrder: this.state.subjectOrder,
            profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId
        };
        
        send(command, this.props.socket, this.props.user.id);

        
        NotificationManager.success("New subject order has been applied.");
    }
    
    sendDeadline = () => {
        let command = {
            type: 'SET_DEADLINE',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            deadline: this.state.deadline,
            subjectId: this.props.match.params.subjectId,
            profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId
        };
        
        send(command, this.props.socket, this.props.user.id);

        
        NotificationManager.success("New deadline has been set.");
    }
    
    sendTask = () => {
        let command = {
            type: 'SEND_TASK',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            task: this.state.task
        };
        
        let cu = this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0];
        let currentSubject = this.props.course.CourseSubject.filter(s => s.id === this.props.match.params.subjectId)[0];
        let chapterName = '';
        let subjectName = '';
        if(currentSubject){
        
            subjectName = currentSubject.name;
            
            let part = null;
            
            currentSubject.CourseChapter.map(c => {
                    let fc = c.ChapterVideo.filter(v => v.id === command.task.value[0].value);
                    if(fc.length > 0){
                        part = fc[0];
                    }
               
            })
            
            if(part){
                                                    
                let chapter = currentSubject.CourseChapter.filter(chapter => {
                  return chapter.id === part.subjectChapterId;
                  });
                
                if(chapter.length > 0){
                  chapterName = chapter[0].name;
                }
            }
        }
        
        command.task.subjectName = subjectName;
        command.task.chapterName = chapterName;
        send(command, this.props.socket, this.props.user.id);
        let {task} = this.state;
        task.title = '';
        task.value = [];
        this.setState({task});
        
        NotificationManager.success("Task recommendation sent.");
        
    }
    
    
    setTestDate = (id, fromModal) => {
        let hasEvent = $("#" + id).data("hasEvent");
        
            this.setState({confirmTestDateModal: true, testDate: id})
        
    
        
        return true;

    }
    
    sendFlag = () => {
        let command = {
            type: 'SEND_FLAG',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            task: this.state.flag,
            profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId
        };
        
        send(command, this.props.socket, this.props.user.id);
        let {flag} = this.state;
        flag.content = '';
        flag.type = 'red';
        this.setState({flag});
    }
    
    sendRestriction = () => {
        let command = {
            type: 'SET_COURSE_STATUS',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            courseStatus: this.state.courseStatus
            
        }
        
        send(command, this.props.socket, this.props.user.id);
        NotificationManager.success("User restriction has been applied.");
    }

    deleteQuiz = (id) => {
        let command = {
            type: 'DELETE_QUIZ_RESULTS',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            quizId: id,
            cuProfileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId,
            profileId: this.props.user.user.Profile.id
        }

    
        send(command, this.props.socket, this.props.user.id);
        NotificationManager.success("Users course progress has been updated");
    }

    editLecture = () => {
        let command = {};
        if(this.state.ul.id){
            command = {
                type: 'EDIT_USERLECTURE',
                courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
                ul: this.state.ul,
                cuProfileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId,
                profileId: this.props.user.user.Profile.id
            }
        }else{
            command = {
                type: 'ADD_USERLECTURE',
                courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
                ul: this.state.ul,
                cuProfileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId,
                profileId: this.props.user.user.Profile.id
            }
        }
        
        send(command, this.props.socket, this.props.user.id);
        NotificationManager.success("Users course progress has been updated");
    }

    removeUserLecture = (id) => {
        let command = {
            type: 'REMOVE_USERLECTURE',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            userLectureId: id,
            cuProfileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId,
            profileId: this.props.user.user.Profile.id
        }

    
        send(command, this.props.socket, this.props.user.id);
        NotificationManager.success("Users course progress has been updated");
    }

    renderCourseCompleted = () => {
        if(this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0]){
            return (
                <input type="checkbox" checked={this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].courseCompleted} onChange={e => {
                    // console.log("Set cu completed to", e.target.value);
                    let {cu} = this.state;
                    cu.courseCompleted = !this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].courseCompleted;
                    this.setState({cu}, () => {
                        this.editCU();
                    })
                }} />
            )
        }else{
            return null;
        }
    }
    
    editCU = () => {
        let command = {
            type: 'EDIT_COURSEUSER',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            cu: this.state.cu,
            profileId: this.props.user.user.Profile.id
        }
        
        send(command, this.props.socket, this.props.user.id);
        NotificationManager.success("Users course progress has been updated");
    }
    
    
    sendNotification = () => {
        let command = {
            type: 'SEND_NOTIFICATION',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            notification: this.state.sendNotification
            
        }
        
        
        send(command, this.props.socket, this.props.user.id);
        $('#sendNotificationModal').modal('hide');
        NotificationManager.success("Notification sent.");
    }
    
    resetCourseUser = () => {
        let command = {
            type: 'RESET_USER',
            courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
            
        }
        send(command, this.props.socket, this.props.user.id);
        $('#resetCourseUserModal').modal('hide');
        NotificationManager.success("This user has been reset.");
    }

    renderQuestionResults = () => {
        return (
            <div className="modal fade" id="VideoQuestionSummaryModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">{this.props.studentProfile.name} scored {this.props.videoQuestions.filter(q => q.attempts === 1 && q.correct).length} questions correct out of {this.props.videoQuestions.length}</h4>
                        </div>
                        <div className="modal-body no-padding" style={{maxHeight: "500px", overflowY: "auto"}}>
                            <div className="">
                            {this.props.videoQuestions.length > 0 ?


                                <table className="table no-margin">
                                    <tbody><tr>
                                        <th>Result</th>
                                        <th>Question</th>
                                        <th>Status</th>
                                    </tr>
                                    {this.props.videoQuestions.map((v, i) => {
                                        return (
                                            <tr key={i}>
                                                <td className="text-center">
                                                    {v.correct ? 
                                                        <i className="zmdi zmdi-check text-success font-24"></i>
                                                    :     <i className="zmdi zmdi-close text-danger font-24"></i>
                                                    }
                                                    </td>

                                                <td>
                                                    <p className="font-14"><a href="#" className="hoverable-text" dangerouslySetInnerHTML={{__html: v.text}}></a></p>
                                                </td>
                                                <td className="text-center"><span className={`${v.attempts > 1 ? 'text-danger' : 'text-success'} font-18`}>{v.attempts}</span></td>
                                            </tr>
                                        )
                                    })}
                                    
                                    
                                </tbody></table>
                                : null
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderTestResults = () => {
        let options = ['0', 'A', 'B', 'C', 'D', 'E'];

        return (
            <div className="modal fade in" id="TestSummaryModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Test Summary</h4>
                        </div>
                        <div className="modal-body">
                        {this.state.test ? 
                            this.state.test.id ?
                        <div className="FinalAnswerToMCQ sp-20">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <p className="font-30 font-300 sm-bottom30">Lecture Quiz Result</p>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <p className="no-margin">Correct</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.state.test.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                    <p className="no-margin">Incorrect</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.state.test.totalQuestions - this.state.test.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                </div>



                                <div className="col-sm-3">
                                    <div className="video-question-summary">
                                        <PieChart
                                            style={{width: 80, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#555'},
                                                {value: this.state.test.correctPercent, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.state.test.correctPercent}%</p>
                                    </div>

                                    </div>
                            </div>
                            <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                                {this.state.test.correctPercent >= 80 ?
                                <span className="text-success"> {this.state.test.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                                    :
                                    <span className="text-danger"> Failed</span>}

                                    </p>


                            

                            <table className="table">
                                <tbody>
                                <tr>
                                    <th className="text-center" style={{width: 50}}>Result</th>
                                    <th className="text-center" style={{width: 100}}>Answered</th>
                                    <th className="text-left">Question</th>
                                    <th className="text-center" style={{width: 122}}>Time Taken</th>
                                </tr>
                                {
                                    this.state.test.sections &&
                                    this.state.test.sections.map((section, si) => {
                                        if(section.subSections){
                                        
                                        return section.subSections.map((ss, ssi) => {
                                            return ss.questions.map((a, i) => {
                                                let seconds = 0;
                                                let timer = "";
                                                if(a.time){
                                                    seconds = parseInt(a.time % 60);
                                                    timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                                        : parseInt(a.time / 60) + ":" + seconds.toString();
                                                }
                                                return (
                                                    <tr key={i}>
                                                        <td className="text-center"><i className={(a.userAnswer === a.correctOption) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                                        <td className="text-center">
                                                            {a.userAnswer}
                                                        </td>
                                                        <td className="text-left">
                                                            <p className="font-14" data-toggle="collapse" data-target={`#LECTURETEST-${si}-${ssi}-${i}`} aria-expanded="false" aria-controls={`#LECTURETEST-${si}-${ssi}-${i}`} dangerouslySetInnerHTML={{__html: a.question}}></p>
                                                            <div className="modalQuizeAnswersOptions collapse" id={`LECTURETEST-${si}-${ssi}-${i}`}>
                                                                            {options.filter(o => o !== '0').map((o, oi) => {
                                                                                if(o === "E"){
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }else{
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html: a["option" + o]}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                                
                                                                            })}
                                                                            
                                                                        </div>
                                                        </td>
                                                        <td className="text-center">{timer}</td>
                                                    </tr>
                                                )
                                            })
                                        })
                                    }else{
                                        return section.questions.map((a, i) => {
                                            let seconds = 0;
                                            let timer = "";
                                            if(a.time){
                                                seconds = parseInt(a.time % 60);
                                                timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                                    : parseInt(a.time / 60) + ":" + seconds.toString();
                                            }
                                            return (
                                                <tr key={i}>
                                                    <td className="text-center"><i className={(a.userAnswer === a.correctOption) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                                    <td className="text-center">
                                                        {a.userAnswer}
                                                    </td>
                                                    <td className="text-left">
                                                        <p className="font-14" data-toggle="collapse" data-target={`#LECTURETEST-${si}-${i}`} aria-expanded="false" aria-controls={`#LECTURETEST-${si}-${i}`} dangerouslySetInnerHTML={{__html: a.question}}></p>
                                                        <div className="modalQuizeAnswersOptions collapse" id={`LECTURETEST-${si}-${i}`}>
                                                                        {options.filter(o => o !== '0').map((o, oi) => {
                                                                            if(o === "E"){
                                                                                return (
                                                                                    <div className="modalQuizeAnswers" key={oi}>
                                                                                        <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                        <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                                    </div>
                                                                                )
                                                                            }else{
                                                                                return (
                                                                                    <div className="modalQuizeAnswers" key={oi}>
                                                                                        <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                        <div className="AnsText" dangerouslySetInnerHTML={{__html: a["option" + o]}}></div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            
                                                                        })}
                                                                        
                                                                    </div>
                                                    </td>
                                                    <td className="text-center">{timer}</td>
                                                </tr>
                                            )
                                        })

                                    }

                                })}
                                </tbody>
                            </table>
                        </div>
                        : null
                        : null }
                        </div>
                        <div className="modal-footer">
                            
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }

    renderQuizResults = () => {
        let options = ['0', 'A', 'B', 'C', 'D', 'E'];

        return (
            <div className="modal fade in" id="QuizSummaryModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Quiz Summary</h4>
                        </div>
                        <div className="modal-body">
                        {this.props.quiz ? 
                            this.props.quiz.id ?
                        <div className="FinalAnswerToMCQ sp-20">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <p className="font-30 font-300 sm-bottom30">Lecture Quiz Result</p>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <p className="no-margin">Correct</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.props.quiz.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                    <p className="no-margin">Incorrect</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.props.quiz.totalQuestions - this.props.quiz.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                </div>



                                <div className="col-sm-3">
                                    <div className="video-question-summary">
                                        <PieChart
                                            style={{width: 80, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#555'},
                                                {value: this.props.quiz.correctPercent, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.props.quiz.correctPercent}%</p>
                                    </div>

                                    </div>
                            </div>
                            <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                                {this.props.quiz.correctPercent >= 80 ?
                                <span className="text-success"> {this.props.quiz.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                                    :
                                    <span className="text-danger"> Failed</span>}

                                    </p>


                            

                            <table className="table">
                                <tbody>
                                <tr>
                                    <th className="text-center" style={{width: 50}}>Result</th>
                                    <th className="text-center" style={{width: 100}}>Answered</th>
                                    <th className="text-left">Question</th>
                                    <th className="text-center" style={{width: 122}}>Time Taken</th>
                                </tr>
                                {
                                    this.props.quiz.answers &&
                                    this.props.quiz.answers.map((a, i) => {
                                        let seconds = parseInt(a.time % 60);
                                        let timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                            : parseInt(a.time / 60) + ":" + seconds.toString();
                                    return (
                                        <tr key={i}>
                                            <td className="text-center"><i className={(a.correct) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                            <td className="text-center">
                                                {options[a.answer]}
                                            </td>
                                            <td className="text-left">
                                                <p className="font-14" data-toggle="collapse" data-target={`#LECTUREQUIZ-${i}`} aria-expanded="false" aria-controls={`#LECTUREQUIZ-${i}`} dangerouslySetInnerHTML={{__html: a.quizQuestionId.question}}></p>
                                                <div className="modalQuizeAnswersOptions collapse" id={`LECTUREQUIZ-${i}`}>
                                                                {options.filter(o => o !== '0').map((o, oi) => {
                                                                    if(o === "E"){
                                                                        return (
                                                                            <div className="modalQuizeAnswers" key={oi}>
                                                                                <div class={`AnsOption ${a.quizQuestionId.correctOption === oi + 1 ? 'bg-success' : a.answer === oi + 1 ? 'bg-danger' : ''}`}>{o}</div>
                                                                                <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                            </div>
                                                                        )
                                                                    }else{
                                                                        return (
                                                                            <div className="modalQuizeAnswers" key={oi}>
                                                                                <div class={`AnsOption ${a.quizQuestionId.correctOption === oi + 1 ? 'bg-success' : a.answer === oi + 1 ? 'bg-danger' : ''}`}>{o}</div>
                                                                                <div className="AnsText" dangerouslySetInnerHTML={{__html: a.quizQuestionId["option" + o]}}></div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    
                                                                })}
                                                                
                                                            </div>
                                            </td>
                                            <td className="text-center">{timer}</td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        : null
                        : null }
                        </div>
                        <div className="modal-footer">
                            {this.props.quiz ?
                                this.props.quiz.id ?
                                    <button type="button" className="btn btn-danger" onClick={e => this.deleteQuiz(this.props.quiz.id)} data-dismiss="modal"><i className="zmdi zmdi-delete" /> Delete Quiz Results</button>
                                : null
                            : null}
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
    
       //Renders
    renderNamePage = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        {this.props.courseUser? 
                            this.props.courseUser[0] ?
                                this.props.courseUser[0].Profile ?
                                    this.props.studentProfile.name + ' ' + this.props.studentProfile.lname
                                : 'Student Profile'
                            : 'Student Profile'
                        : 'Student Profile'}
                    </h1>
                    <small className="text-muted">
                        {this.props.courseUser? 
                            this.props.courseUser[0] ?
                                this.props.courseUser[0].Profile ?
                                    this.props.studentProfile.online ?
                                    <i className="zmdi zmdi-circle text-success" title="Online now" />
                                : null
                                : ''
                            : ''
                        : ''}

                        
                        &nbsp; 
                        Student Profile
                    </small>
                </div>
            </div>
        </div>
    );
    
    renderSubjectTabButtons = () => {
        const {course} = this.props;
        return this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId).map(cu => {
            return cu.subjectOrder.map(s => {
                if(course.CourseSubject){
                    return course.CourseSubject.filter(sub => sub.id === s).map((sub, si) => {
                        let active = false;
                        if(sub.id === this.props.match.params.subjectId){
                            active = true;
                        }else if(si === 0 && !this.props.match.params.subjectId){
                            active = true;
                        }

                        let us = this.props.us.filter(s => s.courseSubjectId === sub.id);
                        let userSubject;
                        if(us){
                            userSubject = us[0];
                        }
                        
                        return (
                            <li className={active ? 'active' : ''}><Link to={`/student-course/${cu.profileId}/${cu.courseId}/${sub.id}`} className="togglePopover" title="" data-original-title="100% completed" aria-expanded="true"><span className="progress-bar-subject" style={{width: userSubject ?  userSubject.completedPercent + "%" : "0%"}}></span> {sub.name}</Link></li>
                        )
                    })   
                }else{
                    return null;
                } 
            })
        
            
        });
    }
    
    // Migrated from dashboard
    buildChart = (view) => {
        let data = [];
        let chartX = [];
        let chartType = 'bar';
        let {attendanceHours, currentSubject} = this.state;
        
        if(view){
            if(this.props.courseUser[0]){
                if(view === 'quiz' && currentSubject && currentSubject !== 'all'){
                    if(this.props.courseUser[0].stats[view].subjects[currentSubject]){
                        data = this.props.courseUser[0].stats[view].subjects[currentSubject].chart;
                        chartX = this.props.courseUser[0].stats[view].subjects[currentSubject].chartX;
                        chartType = this.props.courseUser[0].stats[view].subjects[currentSubject].chartType;
                    }
                }else{
                    data = this.props.courseUser[0].stats[view].chart;
                    chartX = this.props.courseUser[0].stats[view].chartX;
                    chartType = this.props.courseUser[0].stats[view].chartType;
                }
            }
        }

        if(view === 'attendance'){
            attendanceHours = this.props.courseUser[0].stats.attendanceHours.chart;
        }
        
        this.setState({chart: data, chartX, chartType, viewLoaded: true, attendanceHours});

    }
    
    
    
    renderConfigHighchart = (statisticDiagram) => {
        let yName = this.state.view.toUpperCase();
        let self = this;
        let {chartType, chartX} = this.state;

        if(chartType === 'line'){
            if(this.state.view === 'quiz'){

            }else {


                return (
                    {
                        chart: {
                            zoomType: 'line',
                            height: 400,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#2d2d2d'],
                                    [1, '#2d2d2d']
                                ]
                            }
                        },
                        colors: ['#e84a5f','#fff'],
                        title: false,
                        subtitle: false,
                        xAxis: [{
                            categories: chartX,
                            crosshair: true,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            style: {
                                color: '#fff'
                            }
                        }],
                        yAxis: [{ // Primary yAxis
                            labels: {
                                format: '{value}%',
                                style: {
                                    color: '#fff'
                                }
                            },
                            title: {
                                text: 'Video Question Accuracy (percentage)',
                                style: {
                                    color: '#fff'
                                },
                            },
                            min: 0,
                            max: 120,
                            gridLineColor: '#565058'

                        }],
                        tooltip: {
                            shared: true
                        },
                        legend: false,
                        series: statisticDiagram
                    }

                )
            }
        }else if(chartType === 'bar') {
            if(this.state.view === 'quiz'){
                return (
                    {
                        chart: {
                            height: 400,
                            zoomType: 'xy',
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#2d2d2d'],
                                    [1, '#2d2d2d']
                                ]
                            }
                        },
                        colors: ['#e84a5f','#fff'],
                        title: false,
                        subtitle: false,
                        xAxis: [{
                            categories: this.state.chartX,
                            crosshair: true
                        }],
                        yAxis: [{ // Secondary yAxis
                            gridLineColor: '#565058',
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Quiz Percentage',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                format: '{value}%',
                                style: {
                                    color: '#fff'
                                }
                            }

                        }, { // Primary yAxis
                            labels: {
                                format: '{value}x',
                                style: {
                                    color: '#fff'
                                }
                            },
                            title: {
                                text: 'Time Spent On Lecture',
                                style: {
                                    color: '#b15b00'
                                }
                            },
                            
                            opposite: true,
                            gridLineColor: '#565058'

                        }],
                        tooltip: {
                            shared: true
                        },
                        legend: false,
                        series: statisticDiagram
                    }
                )
            }else if(this.state.view === 'efficiency'){
                return ({
                    chart: {
                        zoomType: 'line',
                        height: 400,
                        backgroundColor: {
                            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                            stops: [
                                [0, '#2d2d2d'],
                                [1, '#2d2d2d']
                            ]
                        }
                    },
                    title: false,
                    subtitle: false,
                    
                    colors: ['#e84a5f','#fff'],
                    xAxis: [
                        {
                            categories: this.state.chartX,
                            crosshair: true,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },

                            title: {
                                text: 'Chapter | Part',
                                style: {
                                    color: '#fff'
                                },
                            },
                           
                            gridLineColor: '#555'
                        }
                        

                    ],
                    yAxis: [{ // Primary yAxis
                        labels: {
                            min: 0,
                            format: '{value}',
                            style: {
                                color: '#fff'
                            }
                        },
                        title: {
                            text: 'Efficiency Percentage',
                            style: {
                                color: '#fff'
                            },
                        },
                        min: 0,
                        max: 300,
                        gridLineColor: '#555'
                    }, { // Secondary yAxis
                        title: false,
                        labels: false,
                        opposite: true,
                        gridLineColor: '#555'

                    }],
                    tooltip: {
                        shared: true
                    },

                    legend: {
                        layout: 'horizontal',
                        align: 'left',
                        x: 0,
                        verticalAlign: 'top',
                        y: '100',
                        floating: true
                    },
                    plotOptions: {
                        series: {
                            borderColor: '#e84a5f'
                        }
                    },
                    series: statisticDiagram
                })
            }else if(this.state.view === 'attendance' && this.state.attendanceType === 'graph'){
                return (
                    {
                        chart: {
                            type: 'column',
                            height: 400,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#2d2d2d'],
                                    [1, '#2d2d2d']
                                ]
                            }
                        },
                        colors: ['#fff'],
                        subtitle: false,
                        title: false,
                        xAxis: {
                            type: 'category',
                            categories: this.state.chartX,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            }
                        },
                        yAxis: {
                            title: {
                                text: 'No. of Hours Spent',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            gridLineColor: '#555',

                        },
                        legend: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                borderWidth: 0,
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.y:.1f}'
                                },
                                style: {
                                    color: '#fff'
                                }

                            }
                        },

                        tooltip: {
                            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> of total<br/>'
                        },

                        series: statisticDiagram
                    }
                )
            }
            if(this.state.view === 'completion'){
                return (
                    {
                        chart: {
                            type: 'column',
                            height: 400,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#2d2d2d'],
                                    [1, '#2d2d2d']
                                ]
                            }
                        },
                        legend:false,
                        colors: subjectColors,
                        //colors: ['#8CBF3B', '#333', '#77AA29', '#333', '#FFFC58', '#333', '#EE5389', '#333', '#FE476F', '#333'],
                        //colors: ['#36E33A', '#333', '#00A600', '#333', '#3A7F28', '#333', '#2D631E', '#333', '#224A16', '#333'],
                        //colors: ['#224A16', '#333', '#2D631E', '#333', '#3A7F28', '#333', '#00A600', '#333', '#36E33A', '#333'],
                        //colors: ['#36E33A', '#333', '#00A600', '#333', '#3A7F28', '#333', '#6F7524', '#333', '#986D21', '#333'],
                        //colors: ['#3CF53E', '#333', '#00CF00', '#333', '#53B538', '#333', '#C9A833', '#333', '#C56D21', '#333'],

                        title: false,
                        xAxis: {
                            categories: chartX,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            }
                        },
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Subject Completion',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            gridLineColor: "#555"

                        },
                        tooltip: {
                            pointFormat: '<span style="">{series.name}</span>: <b>{point.y}%</b><br/>',
                            shared: true
                        },
                        plotOptions: {

                            series: {
                                borderColor: 'transparent'
                            }
                        },
                        series: statisticDiagram
                    }
                )
            }else {
                return (
                    {
                        chart: {
                            height: 300,
                            type: 'column',
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#2d2d2d'],
                                    [1, '#2d2d2d']
                                ]
                            }
                        },
                        legend: true,
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: yName
                            }
                        },
                        xAxis: {
                            categories: this.state.chartX
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0,
                                events: {
                                    click: function (e) {

                                        self.buildTestChart(e.point);
                                    }
                                }
                            }
                        },
                        series: statisticDiagram

                    }
                )
            }
        }
        
    };
    
    // End migrate from dashboard
    
    
    renderChapter = (chapter, cu, i) => {
        return (
            <div className="panel customPanel sm-top20">
                <div className="panel-heading bg-light-3">
                    <h3 className="panel-title">Chapter No. {i + 1}</h3>
                </div>
                <div className="panel-body no-padding">
                    <div className="chapter-parts">
                        <div className="chapter-part-wrapper">
                            {chapter.ChapterVideo.map(v => {
                                return (
                                    <div>
                                        {this.renderChapterPart(v, cu)}
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
        
    }
    
    renderQuizPercent = (videoId, cu) => {
        let quizObject = [];
        let quizPercent = '';
        if(cu.Profile){
            if(cu.Profile.ChapterTest){
            quizObject = cu.Profile.ChapterTest.filter(t => t.chapterVideoId === videoId);
            }
        }
        
        quizPercent = 'N/A';
        if (quizObject.length > 0) {
            quizPercent = quizObject[0].correctPercent.toString() + '%';
        }
        
        return quizPercent;
    }
    
    renderPreviousAttempt = (part, index, cu) => {
        return (
            <div className="chapter-part" key={index}>
                <table className="table profile-info-table chapter-part-subtable">
                    <tbody>
                        <tr>
                            <td style={{paddingLeft: "20px", width: "300px"}}>
                            </td>
                            <td className="w-60"></td>
                            <td style={{width: '200px'}}>
                                <p>Time Taken</p>
                                <h3>{moment.duration(part.userTime * 1000).humanize()}</h3>
                            </td>
                            <td>
                                <p>Efficiency</p>
                                <h3>{part.efficiency}%</h3>
                            </td>
                            <td>
                                <p data-toggle="tooltip" title="" data-original-title="Video Questions">VQ</p>
                                <h3><a href="#VideoQuestionSummaryModal" onClick={e => this.props.getVideoQuestions(part.id, this.props.user.id)}  data-toggle="modal"> {part.VideoQuestions ? part.VideoQuestions.length : '0'}</a></h3>
                            </td>
                            <td>
                                
                                <p>Quiz</p>
                                <h3>
                                {part.type === 'test' ?
                                    <a href="#TestSummaryModal" onClick={e => this.setState({test: part})} data-toggle="modal"> {part.correctPercent}%</a>
                                : 
                                    <a href="#QuizSummaryModal"  onClick={e => this.props.getQuizResults(part.id, this.props.user.id)} className="text-danger" data-toggle="modal"> {part.quiz}%</a>
                                }</h3>
                            </td>
                            <td>
                                <div style={{position: 'relative'}}>
                                    <button className="btn btn-transparent edit-lecture-trigger" data-toggle="dropdown"><i className="zmdi zmdi-more-vert" /></button>
                                    <ul className="dropdown-menu edit-lecture-dropdown chapter-dropdown dropdown-menu-right">
                                        <li><a href="#EditLectureModal" data-toggle="modal" onClick={e => this.setState({ul: part})}><i className="zmdi zmdi-edit" /> Edit Lecture Instance</a></li>
                                        <li><a onClick={e => this.removeUserLecture(part.id)}><i className="zmdi zmdi-delete" /> Remove Lecture Instance</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>    
            </div>
        )
    }
    renderChapterPart = (part, cu) => {
        
        let completedPart = this.props.ul.filter(p => p.chapterVideoId === part.id);
        if(completedPart.length > 0){
            let cp = completedPart[completedPart.length - 1];
            let completedPercent = 0;
            if(cp.completed){
                completedPercent = 100;
            }else{
                
                completedPercent = Math.ceil((cp.currentTime / cp.duration) * 100);
            }
            
            return (
                <div className="sp-top0" data-toggle="collapse" data-target={`#LECTURE-${cp.id}`} aria-expanded="false" aria-controls={`#LECTURE-${cp.id}`}>
                    <table className="table profile-info-table" style={{border: "none !important"}}>
                        <tbody><tr>
                            <td style={{paddingLeft: "20px", width: "300px"}}>
                                <h3 className="text-white sm-top-bottom10 overflowedText">{part.title || part.name}</h3>
                                <div className="progress progress-sm no-margin bg-dark dker">
                                    <div className="progress-bar progress-bar-success" style={{width: String(completedPercent) + "%"}}></div>
                                </div>
                            </td>
                            <td className="w-60">
                                <p data-toggle="tooltip" title="Times Attended"><i className="fa fa-eye"></i> </p>
                                <h3>{completedPart.length}</h3>
                            </td>
                            <td style={{width: '200px'}}>
                                <p>Time Taken</p>
                                <h3>{moment.duration(cp.userTime * 1000).humanize()}</h3>
                            </td>
                            <td>
                                <p>Efficiency</p>
                                <h3 style={{width: '65px'}}>{cp.efficiency}%</h3>
                            </td>
                            <td>
                                <p data-toggle="tooltip" title="Video Questions">VQ</p>
                                <h3><a href="#VideoQuestionSummaryModal" onClick={e => this.props.getVideoQuestions(cp.id, this.props.user.id)} data-toggle="modal"> {part.VideoQuestions ? part.VideoQuestions.length : '0'}</a></h3>
                            </td>
                            <td>
                                <p>Quiz</p>
                            <h3>
                                {part.type === 'test' ?
                                    <a href="#TestSummaryModal" onClick={e => this.setState({test: cp})} data-toggle="modal"> {cp.correctPercent}%</a>
                                : 
                                    <a href="#QuizSummaryModal" onClick={e => this.props.getQuizResults(cp.id, this.props.user.id)} data-toggle="modal"> {cp.quiz}%</a>
                                }</h3>
                            </td>
                            <td style={{width: "40px"}} className="text-center">
                                <div style={{position: 'relative'}}>
                                    <button className="btn btn-transparent edit-lecture-trigger" data-toggle="dropdown"><i className="zmdi zmdi-more-vert" /></button>
                                    <ul className="dropdown-menu edit-lecture-dropdown chapter-dropdown dropdown-menu-right">
                                        <li><a href="#EditLectureModal" data-toggle="modal" onClick={e => this.setState({ul: cp})}><i className="zmdi zmdi-edit" /> Edit Lecture Instance</a></li>
                                        <li><a onClick={e => this.removeUserLecture(cp.id)}><i className="zmdi zmdi-delete" /> Remove Lecture Instance</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody></table>

                    {
                        completedPart.length > 1 ?
                            <div className="previous-attempts collapse" id={`LECTURE-${cp.id}`}>
                                {completedPart.filter(p => p.id !== cp.id).map((p, pi) => {
                                    return this.renderPreviousAttempt(p, pi, cu)
                                })}
                            </div>
                        : null
                    }
    
                </div>    
            )
        }else if(cu.currentChapterPart === part.id){
            
            let partPercent = 0;
            if(part.VideoFile){
                if(part.VideoFile[0]){
                    if(part.VideoFile[0].duration){
                        partPercent = cu.currentVideoTime / part.VideoFile[0].duration * 100;
                    }
                }
            }

            let ul = {}
            let ulList = this.props.ul.filter(l => l.chapterVideoId === part.id);
            if(ulList.length > 0){
                ul = ulList[ulList.length - 1];
            }
            
            return (
                <div className="sp-top0" onclick="ToggleTestDetails(this)">
                    <table className="table profile-info-table" style={{border: "none !important"}}>
                        <tbody><tr>
                            <td style={{paddingLeft: "20px", width: "300px"}}>
                                <h3 className="text-white sm-top-bottom10 overflowedText">{part.title || part.name}</h3>
                                <div className="progress progress-sm no-margin bg-dark dker">
                                    <div className="progress-bar progress-bar-success" style={{width: partPercent.toString() + "%"}}></div>
                                </div>
                            </td>
                            <td className="w-60">
                                <p data-toggle="tooltip" title="Times Attended"><i className="fa fa-eye"></i> </p>
                                <h3>0</h3>
                            </td>
                            <td style={{width: '200px'}}>
                                <p>Time Taken</p>
                                <h3>{ul.userTime ? moment.duration((ul.userTime) ? ul.userTime * 1000 : 0).humanize() : 'Not Started'}</h3>
                            </td>
                            <td>
                                <p>Efficiency</p>
                                <h3 style={{width: '65px'}}>0%</h3>
                            </td>
                            <td>
                                <p data-toggle="tooltip" title="Video Questions">VQ</p>
                                <h3><a href="#VideoQuestionSummaryModal" data-toggle="modal">{part.VideoQuestions ? part.VideoQuestions.length : 0}</a></h3>
                            </td>
                            <td>
                                <p>Quiz</p>
                                <h3><a href="#QuizSummaryModal" data-toggle="modal"> 0%</a></h3>
                            </td>
                            <td style={{width: "40px"}} className="text-center">
                                <div  style={{position: 'relative'}}>
                                    <button className="btn btn-transparent edit-lecture-trigger" data-toggle="dropdown"><i className="zmdi zmdi-more-vert" /></button>
                                    <ul className="dropdown-menu edit-lecture-dropdown chapter-dropdown dropdown-menu-right">
                                        {ul.id ?
                                            <li><a href="#EditLectureModal" data-toggle="modal" onClick={e => this.setState({ul: ul})}><i className="zmdi zmdi-edit" /> Edit Lecture Instance</a></li>
                                            :
                                            <li><a href="#EditLectureModal" data-toggle="modal"  onClick={e => {
                                                let ulList = this.props.us.filter(s => s.courseSubjectId === this.props.match.params.subjectId && s.active);
                                                let uli = {};
                                                if(ulList.length > 0){
                                                    uli = ulList[0];
                                                }
                                                const ul = {
                                                    chapterVideoId: part.id,
                                                    courseUserId: cu.id,
                                                    attempts: 1,
                                                    subjectAttempt: cu.subjectAttempt,
                                                    userSubjectId: uli.id,
                                                    courseAttempt: uli.courseAttempt,
                                                    title: '',
                                                    attentiveness: 0,
                                                    efficiency: 0,
                                                    createdOn: new Date(),
                                                    duration: 0,
                                                    currentTime: 0,
                                                    userTime: 0,
                                                    completed: false,
                                                    active: true,
                                                    quiz: 0,
                                                    completion: 0,
                                                    totalPoints: 0,
                                                    points: [],
                                                    maxTime: 0
                                                };
                                                this.setState({ul: ul});
                                        }}><i className="zmdi zmdi-plus" /> Add Lecture Instance</a></li>
                                        }
                                        
                                        
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody></table>
    
                </div>    
            )
        }else{
        
            return (
                <div className="sp-top0">
                    <table className="table profile-info-table" style={{border: "none !important"}}>
                        <tbody><tr>
                            <td style={{paddingLeft: "20px", width: "300px"}}>
                                <h3 className="text-white sm-top-bottom10 overflowedText">{part.title || part.name}</h3>
                                <div className="progress progress-sm no-margin bg-dark dker">
                                    <div className="progress-bar progress-bar-success" style={{width: "0%"}}></div>
                                </div>
                            </td>
                            {cu.courseCompleted ?
                                <td className="w-60">
                                    <p data-toggle="tooltip" title="Times Attended"><i className="fa fa-eye"></i> </p>
                                    <h3>0</h3>
                                </td>
                            :
                                <td className="w-60">
                                    <p data-toggle="tooltip" title="Times Attended"><i className="fa fa-lock"></i> </p>
                                    
                                </td>
                            }
                            <td style={{width: '200px'}}>
                                <p>Time Taken</p>
                                <h3>NA</h3>
                            </td>
                            <td>
                                <p>Efficiency</p>
                                <h3 style={{width: '65px'}}>0%</h3>
                            </td>
                            <td>
                                <p data-toggle="tooltip" title="Video Questions">VQ</p>
                                <h3><a href="#VideoQuestionSummaryModal" data-toggle="modal"> {part.VideoQuestions ? part.VideoQuestions.length : 0}</a></h3>
                            </td>
                            <td>
                                <p>Quiz</p>
                                <h3><a href="#QuizSummaryModal" data-toggle="modal"> 0%</a></h3>
                            </td>
                            <td style={{width: "40px"}} className="text-center">
                                <div style={{position: 'relative'}}>
                                    <button className="btn btn-transparent edit-lecture-trigger" data-toggle="dropdown"><i className="zmdi zmdi-more-vert" /></button>
                                    <ul className="dropdown-menu edit-lecture-dropdown chapter-dropdown dropdown-menu-right">
                                        <li><a href="#EditLectureModal" data-toggle="modal"  onClick={e => {
                                            let ulList = this.props.us.filter(s => s.courseSubjectId === this.props.match.params.subjectId && s.active);
                                            let uli = {};
                                            if(ulList.length > 0){
                                                uli = ulList[0];
                                            }
                                            const ul = {
                                                chapterVideoId: part.id,
                                                courseUserId: cu.id,
                                                attempts: 1,
                                                subjectAttempt: cu.subjectAttempt,
                                                userSubjectId: uli.id,
                                                courseAttempt: uli.courseAttempt,
                                                title: '',
                                                attentiveness: 0,
                                                efficiency: 0,
                                                createdOn: new Date(),
                                                duration: 0,
                                                currentTime: 0,
                                                userTime: 0,
                                                completed: false,
                                                active: true,
                                                quiz: 0,
                                                completion: 0,
                                                totalPoints: 0,
                                                points: [],
                                                maxTime: 0
                                            };
                                            this.setState({ul: ul});
                                    }}><i className="zmdi zmdi-plus" /> Add Lecture Instance</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody></table>
    
                </div>    
            )
        }
    }
    
    renderSubjectContent = () => {
        let {course} = this.props;
        return this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId).map(cu => {
            return cu.subjectOrder.map(s => {
                if(course.CourseSubject){
                    return course.CourseSubject.filter(sub => sub.id === s).map((sub, si) => {
                        let completed = this.props.us.filter(cs => cs.courseSubjectId === sub.id && cs.completed).length > 0;
                        let activeSubList = this.props.us.filter(cs => cs.courseSubjectId === this.props.match.params.subjectId && cs.active);
                        let activeSub;

                        if(activeSubList.length > 0){
                            activeSub = activeSubList[0];
                        }
                        let active = false;
                        if(sub.id === this.props.match.params.subjectId){
                            active = true;
                        }else if(si === 0 && !this.props.match.params.subjectId){
                            active = true;
                        }
                    
                        if(active){
                        
                        return (
                            <div className="tab-pane active" id={`subject_${sub.id}`}>
                                                <div className="sm-top-bottom20">
                                                    <div className="row">

                                                        <div className="col-sm-6">
                                                            <div className="change_subject_deadline_wrapper">
                                                                <div className="change_subject_deadline">
                                                                    <div>
                                                                        {completed ? 'Completed' : activeSub ? 'Active' : 'Inactive'}<br />
                                                                        {completed ? this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0].completedOn : ''}
                                                                    </div>
                                                                    <div>
                                                                        {completed || activeSub ?
                                                                        <i className="zmdi zmdi-check text-success"></i>
                                                                        : null}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="change_subject_deadline_wrapper">
                                                                <div className="change_subject_deadline">
                                                                    {this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0] ?
                                                                    <div>
                                                                        Time Taken: {(completed) ? 
                                                                        this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0].completedOn && this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0].created ?
                                                                        moment(this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0].completedOn).diff(moment(this.props.us.filter(cs => cs.courseSubjectId === sub.id)[0].created), 'days') + ' days'
                                                                        : 'NA'
                                                                        : 
                                                                        activeSub ? moment.duration(moment().diff(moment(cu.currentSubjectStart))).humanize() : 'N/A'
                                                                            
                                                                        }<br />
                                                                        Retakes: {this.props.us.filter(cs => cs.courseSubjectId === sub.id).length - 1 < 0 ? 0 : this.props.us.filter(cs => cs.courseSubjectId === sub.id).length - 1 || 0}
                                                                    </div>
                                                                    : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="panel customPanel no-margin">
                                                    <div className="panel-heading bg-light-3">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <h3 className="panel-title text-center activeTab"><a href="#" onClick={e => {
                                                                    e.preventDefault();
                                                                    this.setState({progressView: 'quiz', progressViewLoaded: false});
                                                                }}>Quiz Progress</a></h3>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <h3 className="panel-title text-center"><a href="#"  onClick={e => {
                                                                    e.preventDefault();
                                                                    this.setState({progressView: 'attentiveness', progressViewLoaded: false});
                                                                }}>Video Question</a></h3>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {this.state.progressViewLoaded &&
                                                    <div className="panel-body">
                                                    
                                                
                                                                {this.state.progressChart &&
                                                                <ReactHighcharts
                                                                    config={this.renderProgressChart(this.state.progressChart)}
                                                                    ref="chart"
                                                                    isPureConfig={false}
                                                                    neverReflow={true}
                                                                    
                                                                />
                                                                }
                                                                
                                                        </div>
                                                    }
                                                </div>

                                                <div>
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    {sub.CourseChapter ? 
                                                        sub.CourseChapter.map((chapter, i) => {
                                                            
                                                            return this.renderChapter(chapter, cu, i)
                                                        })
                                                        : null
                                                    }
                                                    

                                                </div>
                                            </div>
                        )
                        }else{
                            return (
                                <div></div>
                                )
                        }
                    })   
                }else{
                    return null;
                } 
            })
            
        });
        
    }

    renderHeaderLinks = () => {
        const {course} = this.props;
        return (
            <ul className="nav nav-tabs bg-white">
            <li>
                <Link to={`/student-profile/${this.props.courseUser[0].profileId}`}>
                    Overview
                    <span>General Details</span>
                </Link>
            </li>
            
            {this.props.courseUser &&
                this.props.courseUser.length > 0 &&
                    this.props.courseUser.map((cu, i) => {
                        return (
                            <li className={`${(this.props.match.params.courseId === course.id) ? 'active' : ''}`}>
                                <a href={`/student-course/${course.id}`} data-toggle="dropdown">
                                    {course.name}
                                    <span>Course Details <i className="zmdi zmdi-chevron-down font-14 sm-left10 relative" style={{top: "2px"}}></i></span>
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li><a href={`/student-course/${course.id}`}>{course.name} Overview</a></li>
                                        <li><a href="#CourseAnalyticsModal" data-toggle="modal">{course.name} Analytics</a></li>
                                        <li><Link to={`/logs/${cu.id}`}>{course.name} Logs</Link></li>
                                        <li><Link to={`/course-notifications/${cu.id}`}>{course.name} Notifications</Link></li>
                                        <li><Link to={`/red-flags/${cu.id}`}>{course.name} Red Flags</Link></li>
                                    </ul>
                                
    
                                    
                            </li>
                        )       
                    })
                }
                
            </ul>
        )
    }
        

    renderAttendance = (props, state) => {
        
        this.setState({calendarSet: true}, () => {
            let data = [];
            props.courseUser[0].studied.map(a => {
                let d = moment(a.date).format('YYYY-MM-DD');
                let existingDate = data.filter(da => da.date == d);
                
                
                if(existingDate.length > 0){
                    existingDate[0].userTime += a.time;
                    
                    let hours = moment.duration(existingDate[0].userTime*1000).get('hours');
                    let minutes = moment.duration(existingDate[0].userTime*1000).get('minutes');
                    if(hours > 0){
                        existingDate[0].title = "I studied for<br /><br /><span className='text-green'>" +  hours + " hours and " + minutes + " minutes</span>";  
                    }else{
                        existingDate[0].classname = 'bg-yellow'; 
                        existingDate[0].title = "I only studied for<br /><br /><span className='text-yellow'>" + minutes + " minutes</span>";  
                    }
                    
                }else{
                    let hours = moment.duration(a.time*1000).get('hours');
                    let minutes = moment.duration(a.time*1000).get('minutes');
                    let title = "I studied for<br /><br /><span className='text-green'>" +  hours + "hours and " + minutes + " minutes</span>";
                    let className = 'bg-green';
                    if(hours <= 0){
                        className = 'bg-yellow'; 
                        title = "I only studied for<br /><br /><span className='text-yellow'>" + minutes + " minutes</span>";  
                    }
                    data.push({
                        date: moment(a.date).format('YYYY-MM-DD'), 
                        classname: className, 
                        userTime: a.time, 
                        title: title
                    });
                }
            })
            
            let today = moment();
            let started = moment(props.courseUser[0].created);
            let current = started;
            
            while(today.diff(current) > 0){
                let formatted = current.format('YYYY-MM-DD');
                let existingDate = data.filter(d => d.date === formatted);
                if(existingDate.length === 0){
                    data.push({
                        date: current.format('YYYY-MM-DD'), 
                        classname: 'bg-orange', 
                        timeSpent: 0, 
                        title:"<span className='text-danger'>I didn't study</span>"
                        
                    });
                }
                current.add(1, 'days');
            }
            
            //{"date":"2018-07-12","badge":false,"title":"I studied for<br /><br /><span className='text-success'>1 hour 23 minutes and 23 seconds</span>","classname":"bg-success"},
            //{"date":"2018-07-13","badge":false,"title":"<span className='text-danger'>I wasn't online</span>","classname":"bg-orange"},
            $('#attendance-calendar-wrapper').html('<div id="attendance_calendar"></div>');
            $("#attendance_calendar").empty();
            $("#attendance_calendar").zabuto_calendar({
                cell_border: false,
                /*legend: [
                    {type: "block", label: "Deadline Days", classname: "bg-grey"},
                    {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                    {type: "block", label: "Exam Day", classname: "bg-purple"},
                    {type: "block", label: "Graduation", classname: "bg-success"},
                ],*/
                action: function () {
                    //NotificationManager.error("You've already set a test date.");
                },
                action_nav: function(e) { 
                    if(this.id.indexOf('next') > -1){
                        // move next
                        setTimeout(function(){
                            $(document).find(".event-styled").popover({
                            trigger:'hover',
                            container:'body',
                            html:true
                          });
                        }, 500);
                       
                        
                    }else if(this.id.indexOf('prev') > -1){
                        // prev
                        setTimeout(function(){
                            $(document).find(".event-styled").popover({
                            trigger:'hover',
                            container:'body',
                            html:true
                          });
                        }, 500);
                       
                    }
                    
                },
                data: data
            });

            $(document).find(".event-styled").popover({
                trigger:'hover',
                container:'body',
                html:true
              });
        });
    }

    renderProgressChart = (statisticDiagram) => {
        let yName = this.state.progressView.toUpperCase();
        let self = this;
        let {chartType, progressChartX} = this.state;

            if(this.state.progressView === 'quiz'){
                return (
                        {
                            chart: {
                                zoomType: 'xy',
                                height: 200,
                                type: 'spline',
                                backgroundColor: {
                                    linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                    stops: [
                                        [0, '#333'],
                                        [1, '#333']
                                    ]
                                }
                              },
                              colors: ['#e84a5f','#fff'],
                              title: false,
                              subtitle: false,
                              xAxis: [{
                                categories: progressChartX,
                                gridLineColor: '#3a3a3a',
                                title: {
                                    text: 'Quiz Number',
                                    style: {
                                        color: '#fff'
                                    },
                                },
                                labels: {
                                    style: {
                                        color: '#fff'
                                    }
                                },
                              }],
                              yAxis: [{ // Primary yAxis
                                gridLineColor: '#3a3a3a',
                                title: {
                                    text: 'Correct (%)',
                                    style: {
                                        color: '#fff'
                                    },
                                },
                                labels: {
                                    style: {
                                        color: '#fff'
                                    }
                                },
                        
                              }],
                              tooltip: {
                                shared: true
                              },
                              legend: false,
                              series: statisticDiagram
            
                        }
                    )
            }else {
                // attentiveness

                return (
                    {
                        chart: {
                            type: 'column',
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#333'],
                                    [1, '#333']
                                ]
                            },
                
                        },
                        legend:false,
                        yAxis: {
                            gridLineColor: '#3a3a3a',
                            title: {
                                text: 'Time (minutes)',
                                style: {
                                    color: '#fff'
                                },
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            min:0
                        },
                        xAxis:{
                            categories: progressChartX,
                            gridLineColor: '#3a3a3a',
                            title: {
                                text: 'Quiz Number',
                                style: {
                                    color: '#fff'
                                },
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                        },
                        colors: ['#6a6a6a', '#fd5959', '#6CD255', '#fdc54d',],
                        title: false,
                
                
                        tooltip: {
                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                            shared: true
                        },
                        plotOptions: {
                            column: {
                                stacking: 'percent'
                            }
                        },
                        series: statisticDiagram
                    }

                )
            }
        
            
        
    };

    renderTestDate = (props, state) => {
        if(props.courseUser[0].testDate){
            this.setState({testDateConfirmed: props.courseUser[0].testDate, calendarSet: true}, () => {
                let data = [];
                // Get last End Date or today:
                let lastSubject = (this.props.us.length > 0) ? this.props.us[this.props.us.length - 1] : null;
                let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                props.courseUser[0].subjectOrder.map((so, i) => {
                    
                    let subject = props.course.CourseSubject.filter(s => s.id == so)[0];
                    let dateRange = '';
                    if(subject.id === props.courseUser[0].currentSubject){
                        let current = moment();
                        if(props.courseUser[0].currentSubjectStart){
                            current = moment(props.courseUser[0].currentSubjectStart);
                        }else if(this.props.us.length > 0){
                            current = moment(this.props.us[this.props.us.length - 1].completedOn);
                            
                        }
                        
                        
                        let subjectDateSplit = props.courseUser[0].currentSubjectDeadline;
                        let end = moment(subjectDateSplit);
                        lastEndDate = end;
                        
                        while(end.diff(current, 'days') >= 0){
                            let newDate = current.format('YYYY-MM-DD');
                            let d = {date: newDate, classname: 'bg-sub-' + i};
                             data.push(d);
                             current.add(1, 'days');
                        }
                        lastEndDate.add(1, 'days');
                        //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                        
                    }else if(this.props.us.filter(s => s.id === subject.id).length === 0){
                        // Not completed yet, future course
                        let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                        let courseEnd = moment(this.props.courseUser[0].testDate);
                        let subjectsCompleted = this.props.us.length;
                        let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;
        
                        let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                        let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
                        if(i > currentSubjectIndex){
                            // After current subject;
                            let current = moment(lastEndDate.format('YYYY-MM-DD'));
                            let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                            
                            while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                            
                            dateRange = lastEndDate.add(subject.duration, 'days');
        
                        }
                    }else if(this.props.us.filter(s => s.id === subject.id).length > 0){
                        dateRange = moment(this.props.us.filter(s => s.id === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.id === subject.id).completedOn).format('MMM DD')
                    }
                });
                
                let testDate = moment(props.courseUser[0].testDate).format('YYYY-MM-DD');
                if(data.filter(d => d.date == testDate).length > 0 && props.courseUser[0].testDate){
                    let subject = props.course.CourseSubject.filter(s => s.id === props.courseUser[0].currentSubject)[0];
                    
                    NotificationManager.error('You would not meet your test date with this timeline.');
                    this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                }
                
                
                if(props.courseUser[0].testDate){
                    data.push({date: moment(props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                }
                let td = props.courseUser[0].testDate.toString().split('T')[0];
                let self = this;
                $('#attendance-calendar-wrapper').html('<div id="attendance_calendar"></div>');
                $("#attendance_calendar").empty();
                $("#attendance_calendar").zabuto_calendar({
                    cell_border:false,
                    /*legend: [
                        {type: "block", label: "Deadline Days", classname: "bg-grey"},
                        {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                        {type: "block", label: "Exam Day", classname: "bg-purple"},
                        {type: "block", label: "Graduation", classname: "bg-success"},
                    ],*/
                    action: function () {
                        if(self.state.canResetTestDate){
                            let split_date = this.id.split('_');
                            let d = moment(split_date[split_date.length - 1]);
                            let today = moment(new Date());

                            let lengthOfCourse = 0;
                            self.props.course.CourseSubject.map(s => {
                                if(s.duration){
                                    lengthOfCourse += s.duration;
                                }
                            });
                            let earliestTestDate = moment().add(lengthOfCourse, 'days');
                            
                            if(d.diff(today, 'days') < 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else{
                                return self.setTestDate(this.id, false);
                            }
                        }else{
                            
                            NotificationManager.error("You've already set a test date.");
                        }
                    },
                    data: data
                });
            });

        }else if(!props.courseUser[0].testDate){
            let self = this;
            let lengthOfCourse = 0;
            let daysTilTest = 0;
            let data = [];
                            
            props.course.CourseSubject.map(s => {
                if(s.duration){
                    lengthOfCourse += parseInt(s.duration);
                    daysTilTest += parseInt(s.duration);
                }
            });
            
            let current = moment();
            
            while(daysTilTest >= 0){
                data.push({date: current.format('YYYY-MM-DD'), classname: 'bg-danger'});
                current.add(1, 'days');
                daysTilTest--;
            }
            if(!this.state.viewLoaded){
            this.setState({viewLoaded: true}, () => {
                $('.calendar_1').html('<div id="test_calendar"></div>');
                $("#test_calendar").empty();
                $("#test_calendar").zabuto_calendar({
                    cell_border: false,
                    /*legend: [
                        {type: "block", label: "Deadline Days", classname: "bg-grey"},
                        {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                        {type: "block", label: "Exam Day", classname: "bg-purple"},
                        {type: "block", label: "Graduation", classname: "bg-success"},
                    ],*/
                    action: function () {
                    if(self.state.view !== 'attendance'){
                        let split_date = this.id.split('_');
                        let d = moment(split_date[split_date.length - 1]);
                        let today = moment(new Date());

                            
                            let earliestTestDate = moment().add(lengthOfCourse, 'days');
                            if(today.diff(d, 'days') > 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else{
                                return self.setTestDate(this.id, false);
                            }
                    }
                },
                data: data
                });
            });
        }
        }

    }

    sameMonth = (a, b, other) => {
        if (a.month() !== b.month()) {
            return other;
        }
        return a.date();
    }

    getWeeks = (m) => {
        let lastOfMonth     = m.clone().endOf('month'),
            lastOfMonthDate = lastOfMonth.date(),
            firstOfMonth    = m.clone().startOf('month'),
            currentWeek     = firstOfMonth.clone().day(0),
            output          = [],
            startOfWeek,
            endOfWeek;

        while (currentWeek < lastOfMonth) {
            startOfWeek = this.sameMonth(currentWeek.clone().day(0), firstOfMonth, 1);
            endOfWeek = this.sameMonth(currentWeek.clone().day(6), firstOfMonth, lastOfMonthDate);

            output.push({start: startOfWeek, end: endOfWeek});
            currentWeek.add('d', 7);
        }

        return output;
    }


    buildProgressChart = (view) => {
        let data = [];
        let progressChartX = [];
        let chartType = 'bar';
        let {attendanceHours, currentSubject} = this.state;
        
        if(view){
            if(view === 'attentiveness') {
                data = [
                    {
                        borderColor: 'none',
                        name: 'Total time taken',
                        data: []
                    }, {
                        borderColor: 'none',
                        name: 'Time Wasted',
                        data: []
                    },{
                    borderColor: 'none',
                    name: 'Time Studied',
                    data: []
                }, {
                    borderColor: 'none',
                    name: 'Video time',
                    data: []
                } ];
                chartType = 'line';
                this.props.ul.map((v, i) => {
                    progressChartX.push(v.title);
                    
                    data[0].data.push(v.userTime / 60);
                    data[1].data.push(0); // Make this be timeWasted
                    data[2].data.push(v.userTime / 60); // This should be userTime - timeWasted
                    data[3].data.push(v.duration / 60);
    
                })
    
            }else{
                if(this.props.courseUser[0]){
                    if(view === 'quiz' && currentSubject && currentSubject !== 'all'){
                        if(this.props.courseUser[0].stats[view].subjects[currentSubject]){
                            data = this.props.courseUser[0].stats[view].subjects[currentSubject].chart;
                            progressChartX = this.props.courseUser[0].stats[view].subjects[currentSubject].chartX;
                            chartType = this.props.courseUser[0].stats[view].subjects[currentSubject].chartType;
                        }
                    }else{
                        data = this.props.courseUser[0].stats[view].chart;
                        progressChartX = this.props.courseUser[0].stats[view].chartX;
                        chartType = this.props.courseUser[0].stats[view].chartType;
                    }
                }
            }
        }

        if(view === 'attendance'){
            attendanceHours = this.props.courseUser[0].stats.attendanceHours.chart;
        }
        this.setState({progressChart: data, progressChartX, chartType, progressViewLoaded: true, attendanceHours});

    }

    buildProgressChartOld = (view) => {
        let data = [];
        let progressChartX = [];
        let chartType = 'bar';
        let {attendanceHours} = this.state;

        if(view === 'attentiveness') {
            data = [
                {
                    borderColor: 'none',
                    name: 'Total time taken',
                    data: []
                }, {
                    borderColor: 'none',
                    name: 'Time Wasted',
                    data: []
                },{
                borderColor: 'none',
                name: 'Time Studied',
                data: []
            }, {
                borderColor: 'none',
                name: 'Video time',
                data: []
            } ];
            chartType = 'line';
            this.props.ul.map((v, i) => {
                progressChartX.push(v.title);
                
                data[0].data.push(v.userTime / 60);
                data[1].data.push(0); // Make this be timeWasted
                data[2].data.push(v.userTime / 60); // This should be userTime - timeWasted
                data[3].data.push(v.duration / 60);

            })

        }else if(view === 'quiz'){
            data = [{
                name: 'Correct',
                type: 'spline',
                yAxis: 0,
                data: []
            }, {
                name: 'Incorrect',
                type: 'spline',
                data: []
            }]

            let subject = null;
            let chapterIds = [];
            if(this.state.currentSubject !== null || this.state.currentSubject !== 'all' && this.props.course){
                subject = this.state.currentSubject;
                this.props.course.CourseSubject.map(s => {
                    if(s.id === subject){
                        s.CourseChapter.map(c => {
                            chapterIds.push(c.id);
                        })
                    }
                })
            }

            //data = [{name: 'Quiz Performance', data: []}];
            this.props.ul.map((v, i) => {
                let process = false;
                if(subject && chapterIds.indexOf(v.subjectChapterId) > -1 || subject === null || subject === 'all'){
                    process = true;
                }

                if(process === true) {
                    progressChartX.push(i + 1);
                    let lecture = 0;

                    let quiz = this.props.studentProfile.ChapterTest.filter(t => t.chapterVideoId === v.id);

                    if (quiz.length > 0) {
                        lecture = quiz[0].correctPercent;
                        data[0].data.push(lecture);
                        lecture = (100 - quiz[0].correctPercent);
                        data[1].data.push(lecture);
                    } else {
                        lecture = 0;
                    }
                    
                }
            })

        }
        this.setState({progressChart: data, progressChartX, chartType, progressViewLoaded: true, attendanceHours});

    }
    
    updateTimer = () => {
        this.setState({timeLeft: this.state.timeLeft - 1, estimatedTime: this.state.estimatedTime + 1, timeToTest: this.state.timeToTest - 1});
    }
    
    componentWillUnmount(){
        clearInterval(this.timerId);
    }
    

    componentWillUpdate(props, state){
        let cuUpdated = (props.courseUser[0] !== this.props.courseUser[0]);
        let {improvement, currentSubject, studiedLastMonth, studiedTotal, studiedAverage, subjectDate,
            studiedThisWeek, attentiveThisWeek, quizScoreThisWeek, efficiencyThisWeek, recommendationsThisWeek, unitsThisWeek
        } = this.state;
        
        if(props.courseUser[0] !== this.props.courseUser[0] && props.courseUser[0].id){
            // console.log("GETTING US");
            this.props.getCompletedSubjects(props.courseUser[0].id, props.user.id);
        }
        if(props.us !== this.props.us || props.match.params.subjectId !== this.props.match.params.subjectId){
            if(props.us){
                let us = props.us.filter(p => p.courseSubjectId === props.match.params.subjectId);
                if(us.length > 0){
                    this.props.getCompletedLectures(us[0].id, props.user.id);
                }
            }
        }

        if(props.courseUser.length === 0){
            return false;
        }else{
            if(props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0]){
                if(state.subjectOrder.length === 0 && props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].subjectOrder.length > 0){
                    this.setState({subjectOrder: props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].subjectOrder});
                }
            }

            
        if(props.courseUser[0] && (!this.state.loaded || this.props.courseUser[0] !== props.courseUser[0]) || (this.props.match.params.subjectId !== props.match.params.subjectId)){
            this.setState({loaded: true}, () => {
            if(!this.timerId || (this.props.match.params.subjectId !== props.match.params.subjectId) || props.courseUser[0].testDate != this.props.courseUser[0].testDate || props.courseUser[0].currentSubjectDeadline != this.props.courseUser[0].currentSubjectDeadline || this.props.courseUser[0] !== props.courseUser[0]){
                
                    
                    let totalSeconds, chapterSeconds, currentChapter, totalTime;
                    
                    let secondsLeft = moment.duration(moment(new Date(props.courseUser[0].currentSubjectDeadline)).diff(moment())).as('seconds');
                    let timeTaken = moment.duration(new Date() - new Date(props.courseUser[0].currentSubjectStart)).as('seconds');
                    
                    let expectedTime;
                    
                    let videosInCourse = 0;
                    if(props.course){

                      if(props.course.CourseSubject) {
                          
            
                        props.course.CourseSubject.map((subject, si) => {
                            if(subject.CourseChapter){
                                subject.CourseChapter.map((chapter) => {
                                    videosInCourse += chapter.ChapterVideo.filter(v => v.status != false).length;
                                })
                                }
                        })
                      }
                    }
                      
                      let started = new Date(props.courseUser[0].currentSubjectStart);
                      let deadline = new Date(props.courseUser[0].currentSubjectDeadline);
                      let today = new Date();
                      // Days from start to deadline
                      let totalDiff = moment.duration(moment(new Date(props.courseUser[0].currentSubjectDeadline)).diff(moment(props.courseUser[0].currentSubjectStart))).as('days'); // (deadline - started) / (1000);
                      
                      // Days from start to now
                      let actualDiff = moment.duration(moment(new Date()).diff(moment(props.courseUser[0].currentSubjectStart))).as('days');
                      let completedVideos = this.props.ul.length;
            
                      // How many videos must be completed per day to meet deadline:
                      let estimatedAverage =  videosInCourse / Math.ceil(totalDiff);
                      // How many videos are being completed per day on average
                      
                      let requiredPerDay = Math.ceil(estimatedAverage);
                      let actualAverage = completedVideos / Math.ceil(actualDiff);
                      
                      let estimatedDays = videosInCourse / actualAverage;
                      // avg completed = completed / (86400 * daysSinceStart) (1 day) = 2
                      // estimatedComplete = avg (2) * daysRemaining
                      
                      let estimatedSecondsToComplete;
                      
                      if(actualDiff !== Infinity){
                          if(actualDiff > 0){
                            //let s = 86400 * estimatedAverage;
                            estimatedSecondsToComplete = moment.duration(estimatedDays*86400*1000).as('seconds');
                          }
                      }

                      let estimatedTimeClass = 'green';

                        if (props.courseUser[0].estimatedFinishDate) {
                            estimatedSecondsToComplete = moment.duration(moment(props.courseUser[0].estimatedFinishDate).diff(moment())).as('seconds');
                        }
            
                        if(secondsLeft == 0){
                            estimatedTimeClass = 'red';
                        }else if (estimatedSecondsToComplete < secondsLeft) {
                            estimatedTimeClass = 'green';
                      }else if(estimatedSecondsToComplete > secondsLeft){
                          estimatedTimeClass = 'yellow';
                      }
                      
                      let timeToTest = -1;
                      if(props.courseUser[0].testDate){
                          timeToTest = moment.duration(moment(props.courseUser[0].testDate).diff(moment())).as('seconds');
                      }



                    this.setState({setTimer: true, timeLeft: secondsLeft, timeTaken: timeTaken, estimatedTime: estimatedSecondsToComplete, estimatedTimeClass: estimatedTimeClass, timeToTest, requiredPerDay}, () => {

                        if (!this.timerId) {
                            // Initiate lecture timer
                            this.timerId = setInterval(this.updateTimer, 1000);

                        }
                    })


                    
                }
            
            
            if(props.courseUser[0].testDate && !props.courseUser[0].completedCourse){
                let td = moment(props.courseUser[0].testDate);
                let today = moment(new Date());

                if(today.diff(td, 'days') >= 0 && this.state.canResetTestDate === false){
                    
                    this.setState({canResetTestDate: true});
                }else if(today.diff(td, 'days') < 0 && this.state.canResetTestDate === true){
                        this.setState({canResetTestDate: false});
                    
                }
            }
            
            
            if(props.course){
                if(currentSubject === null && props.course.CourseSubject){
                    currentSubject = props.courseUser[0].currentSubject;
                    let subject = props.course.CourseSubject.filter(s => s.id === currentSubject)[0];
                    if(subject){
                        if(!props.courseUser[0].currentSubjectDeadline && !subjectDate && subject.duration){
                            let d = moment().add(subject.duration - 1, 'days');
                            subjectDate = 'zabutocalendar_' + d.format('YYYY-MM-DD');
                        }
                    }
                }
            }

            if(studiedLastMonth === null && props.courseUser.length > 0){
                let d = parseInt(moment(new Date()).subtract(1, 'months').format('MM'));
                let studiedDates = [];

                props.courseUser[0].studied.map(a => {
                    let item = parseInt(moment(a.date).format('MM'));
                    if(item === d) {
                        let dayToPush = moment(a.date).format('DD');
                        if (studiedDates.indexOf(dayToPush) === -1) {

                            studiedDates.push(dayToPush);
                        }
                    }
                });

                studiedLastMonth = studiedDates.length;
                studiedLastMonth = studiedDates.length.toString() + ' days (' + Math.floor((studiedDates.length / parseInt(moment(new Date()).subtract(1, 'months').daysInMonth())) * 100) + '%)';
            }
            
            if(studiedThisWeek === null && props.courseUser.length > 0){
                let d = moment(new Date()).subtract(7, 'days');
                let studiedDates = [];

                props.courseUser[0].studied.map(a => {
                    let item = moment(a.date);
                    if(item.diff(d, 'days') > 0) {
                        let dayToPush = moment(a.date).format('DD');
                        if (studiedDates.indexOf(dayToPush) === -1) {

                            studiedDates.push(dayToPush);
                        }
                    }
                });
                
                studiedThisWeek = studiedDates.length;
            }
            
            if(attentiveThisWeek === null && props.courseUser.length > 0){
               
                let relevantVideos = this.props.ul.filter(p => moment().diff(moment(p.completedOn), 'days') < 7);
                let totalVideos = relevantVideos.length;
                let totalAttentive = 0;

                relevantVideos.map(v => {
                    totalAttentive += (v.attentive) ? v.attentive : 100;
                    
                })
                
                attentiveThisWeek = (totalAttentive / relevantVideos.length);
            }
            
            if(unitsThisWeek === null && props.courseUser.length > 0){
                let relevantVideos = this.props.ul.filter(p => moment().diff(moment(p.completedOn), 'days') < 7);
                unitsThisWeek = (relevantVideos.length / 7).toFixed(2);
            }
            
            
            if(quizScoreThisWeek === null && props.courseUser.length > 0){
                let totalScore = 0;
                let quizObject = [];

                this.props.ul.filter(p => moment().diff(moment(p.completedOn), 'days') < 7).map(v => {
                    if(v.quiz){
                        quizObject.push(v.quiz);
                        totalScore = totalScore + Number(v.quiz);
                        // console.log("Adding", v.quiz, "to", totalScore);
                    }
                });
                quizScoreThisWeek = (totalScore / quizObject.length).toFixed(2);

                
                
            }
            
            if(efficiencyThisWeek === null && props.courseUser.length > 0){
                let totalEfficiency = 0;
                let relevantVideos = this.props.ul.filter(p => moment().diff(moment(p.completedOn), 'days') < 7).map(v => {
                    totalEfficiency += v.efficiency;
                    return v;
                });
                
                efficiencyThisWeek = (totalEfficiency / relevantVideos.length).toFixed(2);
                
            }
            
            
            /*
                studiedThisWeek: null,
                attentiveThisWeek: null,
                quizScoreThisWeek: null,
                unitsThisWeek
                efficiencyThisWeek: null,
                recommendationsThisWeek: null,
            */

            if(studiedTotal === null){
                let c = moment(props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days');
                let daysStudied = [];

                props.courseUser[0].studied.map(a => {
                    let dayToPush = moment(a.date).format('YYYY-MM-DD');
                    if (daysStudied.indexOf(dayToPush) === -1) {
                        daysStudied.push(dayToPush);
                    }
                });
                
                let stp = Math.floor((daysStudied.length / totalDays) * 100);
                if(stp == Infinity){
                    stp = 100;
                }
                if(isNaN(stp)){
                    stp = 0;
                }

                studiedTotal = daysStudied.length.toString() + ' days (' + stp + '%)';
            }

            if(studiedAverage === null){
                let c = moment(props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days');

                let timeStudied = 0;
                props.courseUser[0].studied.map(part => {
                    timeStudied += part.time;
                });

                studiedAverage = (timeStudied / 60 / 60).toFixed(2).toString() + ' Hours';

            }

            // Build attendance improvement
            if(improvement.attendance === null) {
                let attendanceNow = 0;
                let attendanceBefore = 0;
                let today = moment();

                props.courseUser[0].studied.map(a => {
                    let item = moment(a.date);
                    if (today.diff(item, 'days') <= 7) {
                        attendanceNow += 1;
                    } else if (today.diff(item, 'days') >= 7 && today.diff(item, 'days') <= 14) {
                        attendanceBefore += 1;
                    }
                })

                if(attendanceBefore > attendanceNow){

                    if(attendanceNow == 0){
                        improvement.attendance = {
                            type: 'down',
                            value: 100
                        }
                    }else {
                        improvement.attendance = {
                            type: 'down',
                            value: Math.ceil((attendanceBefore / attendanceNow) * 100) || 0
                        }
                    }
                }else if(attendanceNow > attendanceBefore){
                    if(attendanceBefore === 0){
                        improvement.attendance = {
                            type: 'up',
                            value: 100
                        }
                    }else{
                        improvement.attendance = {
                            type: 'up',
                            value: Math.ceil((attendanceNow / attendanceBefore) * 100) || 0
                        }
                    }

                }


            }

            let self = this;
            $("#test_calendar").zabuto_calendar({
                cell_border:false,
                /*legend: [
                    {type: "block", label: "Deadline Days", classname: "bg-grey"},
                    {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                    {type: "block", label: "Exam Day", classname: "bg-purple"},
                    {type: "block", label: "Graduation", classname: "bg-success"},
                ],*/
                action: function () {
                    if(self.state.canResetTestDate){
                        let split_date = this.id.split('_');
                        let d = moment(split_date[split_date.length - 1]);
                        let today = moment(new Date());

                        let lengthOfCourse = 0;
                        self.props.course.CourseSubject.map(s => {
                            if(s.duration){
                                lengthOfCourse += s.duration;
                            }
                        });
                        let earliestTestDate = moment().add(lengthOfCourse, 'days');
                        
                        if(d.diff(today, 'days') < 0){
                            NotificationManager.error('You cannot set your test date to a past date.');
                        }else{
                            return self.setTestDate(this.id, false);
                        }
                    }else{
                        
                        NotificationManager.success('Setting test date');
                        return self.setTestDate(this.id, false);
                    }
                },
                data: []
            });

            this.setState({
                improvement, 
                currentSubject, 
                studiedTotal, 
                studiedLastMonth, 
                studiedAverage, 
                subjectDate, 
                studiedThisWeek,
                attentiveThisWeek,
                unitsThisWeek,
                quizScoreThisWeek,
                efficiencyThisWeek,
                recommendationsThisWeek});



            if(this.state.completionPercent === null && props.courseUser[0]){
                if(props.course){
                    if(props.course.CourseSubject){
                        let completionPercent = 0;
                        let totalSubjectLength = 0;
                        let completedVideos = 0;
                        props.course.CourseSubject.map((subject, i) => {
            
            
                            let videoIds = [];
                            if(subject.CourseChapter){
            
                            subject.CourseChapter.map(c => {
                                totalSubjectLength += c.ChapterVideo.filter(v => v.status !== false).length;
            
                                c.ChapterVideo.map(v => {
                                    videoIds.push(v.id);
                                })
                            })
                            
                            completedVideos += this.props.ul.filter(v => videoIds.indexOf(v.chapterVideoId) > -1).length || 0;
                        }
            
            
                        })
            
                        completionPercent = (completedVideos / totalSubjectLength) * 100 || 0;
                        
                        if(completionPercent.toString().indexOf('.') > -1){
                            completionPercent = completionPercent.toFixed(1);
                        }
            
                        this.setState({completionPercent});
                    }
                }
            }
        });
        }
            
            
            if(props.courseUser[0]) {
                if(props.courseUser[0].testDate && !this.state.testDateConfirmed){
                    let data = [];
                    // Get last End Date or today:
                    let lastSubject = (this.props.us.length > 0) ? this.props.us[this.props.us.length - 1] : null;
                    let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                    props.courseUser[0].subjectOrder.map((so, i) => {
                        if(props.course){
                            if(props.course.CourseSubject){
                            
                            let subject = props.course.CourseSubject.filter(s => s.id == so)[0];
                            let dateRange = '';
                            if(subject){
                            if(subject.id === props.courseUser[0].currentSubject){
                                let current = moment();
                                if(props.courseUser[0].currentSubjectStart){
                                    current = moment(props.courseUser[0].currentSubjectStart);
                                }else if(this.props.us.length > 0){
                                    current = moment(this.props.us[this.props.us.length - 1].completedOn);
                                    
                                }
                                
                                
                                let subjectDateSplit = state.subjectDate.split('_')
                                let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                                lastEndDate = end;
                                
                                while(end.diff(current, 'days') >= 0){
                                    let newDate = current.format('YYYY-MM-DD');
                                    let d = {date: newDate, classname: 'bg-sub-' + i};
                                    data.push(d);
                                    current.add(1, 'days');
                                }
                                lastEndDate.add(1, 'days');
                                //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                                
                            }else if(this.props.us.filter(s => s.id === subject.id).length === 0){
                                // Not completed yet, future course
                                let lastEnd = moment((lastSubject) ? lastSubject.completedOn : new Date());
                                let courseEnd = moment(props.courseUser[0].testDate);
                                let subjectsCompleted = this.props.us.length;
                                let subjectsToComplete = props.courseUser[0].subjectOrder.length;
                
                                let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                                let currentSubjectIndex = props.courseUser[0].subjectOrder.indexOf(props.courseUser[0].currentSubject);
                                if(i > currentSubjectIndex){
                                    // After current subject;
                                    let current = moment(lastEndDate.format('YYYY-MM-DD'));
                                    let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                                    
                                    while(end.diff(current, 'days') >= 0){
                                        let newDate = current.format('YYYY-MM-DD');
                                        let d = {date: newDate, classname: 'bg-sub-' + i};
                                        data.push(d);
                                        current.add(1, 'days');
                                    }
                                    
                                    dateRange = lastEndDate.add(subject.duration, 'days');
                
                                }
                            }else if(this.props.us.filter(s => s.id === subject.id).length > 0){
                                dateRange = moment(this.props.us.filter(s => s.id === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.id === subject.id).completedOn).format('MMM DD')
                            }
                            }
                        }
                    }
                    });
                    
                    let testDate = moment(props.courseUser[0].testDate).format('YYYY-MM-DD');
                    if(data.filter(d => d.date == testDate).length > 0 && props.courseUser[0].testDate){
                        let subject = props.course.CourseSubject.filter(s => s.id === props.courseUser[0].currentSubject)[0];
                        
                        if(subject){
                            NotificationManager.error('You would not meet your test date with this timeline.');
                            this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                        }
                    }
                    
                    
                    if(props.courseUser[0].testDate){
                        data.push({date: moment(props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                    }
                    
                    this.setState({testDateConfirmed: props.courseUser[0].testDate}, () => {
                        /*
                        let td = props.courseUser[0].testDate.toString().split('T')[0];
                        let self = this;
                        $("#test_calendar").zabuto_calendar({
                            cell_border:false,
                            
                            action: function () {
                                if(self.state.view !== 'attendance'){
                                    NotificationManager.error("You've already set a test date.");
                                }
                            },
                            data: data
                        });
                        
                        */
                    });
        
                }else if(!props.courseUser[0].testDate){
                    let self = this;
                    $("#test_calendar").zabuto_calendar({
                        cell_border:false,
                        /*legend: [
                            {type: "block", label: "Deadline Days", classname: "bg-grey"},
                            {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                            {type: "block", label: "Exam Day", classname: "bg-purple"},
                            {type: "block", label: "Graduation", classname: "bg-success"},
                        ],*/
                        action: function () {
                            if(self.state.view !== 'attendance'){
                                let split_date = this.id.split('_');
                                let d = moment(split_date[split_date.length - 1]);
                                let today = moment(new Date());
                                let lengthOfCourse = 0;
                                self.props.course.CourseSubject.map(s => {
                                    if(s.duration){
                                        lengthOfCourse += s.duration;
                                    }
                                });
                                let earliestTestDate = moment().add(lengthOfCourse, 'days');
                                
                                if(d.diff(today, 'days') > 0){
                                    NotificationManager.error('You cannot set your test date to a past date.');
                                }else if(d.diff(today, 'days') > lengthOfCourse){

                                    NotificationManager.error('You would not have time to complete this course if you choose that date.');
                                }else{
                                    return self.setTestDate(this.id, false);
                                }
                            }
                        }
                    });
                }
            }
            
            if(props.courseUser[0]){
            
            if(this.state.subjectDate !== state.subjectDate || props.courseUser[0].testDate != props.courseUser[0].testDate){
            
            
            if(props.courseUser[0].currentSubjectDeadline && !this.state.subjectDateConfirmed || state.timeLeft <= 0){
                let self = this;
    
                let data = [];
                let beginRemaining;
                if(state.subjectDate){
                    let split_date = state.subjectDate.split('_');
                    split_date = split_date[split_date.length - 1];
    
                    beginRemaining = moment(split_date);
                    let fromNowToEnd = beginRemaining.diff(moment(), 'days');
    
                    while(fromNowToEnd >= 0){
                        let newDate = moment(beginRemaining).subtract(fromNowToEnd, 'days').format('YYYY-MM-DD');
                        let d = {date: newDate, classname: 'bg-primary'};
                        data.push(d);
    
                        fromNowToEnd--;
                    }
                }else{
                    beginRemaining = moment();
                }
    
    
                let remaining = moment(props.courseUser[0].testDate).diff(beginRemaining, 'days');
                remaining -= 1;
    
                while(remaining > 0){
                    let newDate = moment(props.courseUser[0].testDate).subtract(remaining, 'days').format('YYYY-MM-DD');
                    let d = {date: newDate, classname: 'bg-danger'};
                    data.push(d);
                    remaining--;
                }
    
                $("#deadline_calendar").zabuto_calendar({
                    language: "en",
                    cell_border: false,
                    action: function(e){
                        if (self.props.courseUser[0].currentSubjectDeadline) {
                            //alert("You clicked on an event4");
                            self.setState({confirmSubjectDateModal: true, subjectDate: this.id})
                        }else{
                            //alert("You clicked on an event5");
                            self.setState({confirmSubjectDateModal: true, subjectDate: this.id})
                        }
                        return true;
                    },
                    data: data
                });
            }else if(!props.courseUser[0].currentSubjectDeadline || this.state.subjectDate !== state.subjectDate || props.courseUser[0].currentSubjectDeadline != props.courseUser[0].currentSubjectDeadline){
                let self = this;
    
    
                let data = [];
                let beginRemaining;
                
                
                // Get last End Date or today:
                let lastSubject = (this.props.us.length > 0) ? this.props.us[this.props.us.length - 1] : null;
                let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                props.courseUser[0].subjectOrder.map((so, i) => {
                    
                    let subject = props.course.CourseSubject.filter(s => s.id == so)[0];
                    let dateRange = '';
                    if(subject){
                    if(subject.id === props.courseUser[0].currentSubject){
                        let current = moment();
                        
                        let subjectDateSplit = state.subjectDate.split('_')
                        let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                        lastEndDate = end;
                        
                        while(end.diff(current, 'days') >= 0){
                            let newDate = current.format('YYYY-MM-DD');
                            let d = {date: newDate, classname: 'bg-sub-' + i};
                             data.push(d);
                             current.add(1, 'days');
                        }
                        lastEndDate.add(1, 'days');
                        //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                        
                    }else if(this.props.us.filter(s => s.id === subject.id).length === 0){
                        // Not completed yet, future course
                        let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                        let courseEnd = moment(props.courseUser[0].testDate);
                        let subjectsCompleted = this.props.us.length;
                        let subjectsToComplete = props.courseUser[0].subjectOrder.length;
        
                        let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                        let currentSubjectIndex = props.courseUser[0].subjectOrder.indexOf(props.courseUser[0].currentSubject);
                        if(i > currentSubjectIndex){
                            // After current subject;
                            let current = moment(lastEndDate.format('YYYY-MM-DD'));
                            let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                            
                            while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                            
                            dateRange = lastEndDate.add(subject.duration, 'days');
        
                        }
                    }else if(this.props.us.filter(s => s.id === subject.id).length > 0){
                        let curSubject = this.props.us.filter(s => s.id === subject.id)[0];
                        
                        // Rendering completed subject:
                        let current = moment(curSubject.subjectStarted);
                        let end = moment(curSubject.completedOn);
                        while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                        
                        dateRange = moment(this.props.us.filter(s => s.id === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.id === subject.id).completedOn).format('MMM DD')
                    }
                    }
                });
                
                let testDate = moment(props.courseUser[0].testDate).format('YYYY-MM-DD');
                if(data.filter(d => d.date == testDate).length > 0 && props.courseUser[0].testDate){
                    let subject = props.course.CourseSubject.filter(s => s.id === props.courseUser[0].currentSubject)[0];
                    
                    if(subject){
                        NotificationManager.error('You would not meet your test date with this timeline.');
                        this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                    }
                }
                
                
                if(props.courseUser[0].testDate){
                    data.push({date: moment(props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                }
                
                /*
                //OLD

                if(state.subjectDate){
                    let split_date = state.subjectDate.split('_');
                    split_date = split_date[split_date.length - 1];
    
                    beginRemaining = moment(split_date);
                    let fromNowToEnd = beginRemaining.diff(moment(), 'days');
                    while(fromNowToEnd >= 0){
                        let newDate = moment(beginRemaining).subtract(fromNowToEnd, 'days').format('YYYY-MM-DD');
                        let d = {date: newDate, classname: 'bg-primary'};
                        data.push(d);
    
                        fromNowToEnd--;
                    }
                }else{
                    beginRemaining = moment();
                }
    
    
                let remaining = moment(props.courseUser[0].testDate).diff(beginRemaining, 'days');
                remaining -= 1;
    
                while(remaining > 0){
                    let newDate = moment(props.courseUser[0].testDate).subtract(remaining, 'days').format('YYYY-MM-DD');
                    let d = {date: newDate, classname: 'bg-danger'};
                    data.push(d);
                    remaining--;
                }
                */
    
                $('.subjectDeadlineContainer').html('<div id="deadline_calendar"></div>');
                $("#deadline_calendar").empty();
                $("#deadline_calendar").zabuto_calendar({
                    language: "en",
                    cell_border: false,
                    month: (this.state.subjectDate) ? new Date(this.state.subjectDate.split('_')[this.state.subjectDate.split('_').length - 1]).getMonth() + 1 : new Date().getMonth() + 1,
                    action: function(e){
                        if (self.props.courseUser[0].currentSubjectDeadline) {
                            //alert("You clicked on an event2");
                            let split_date = this.id.split('_');
                            let d = moment(split_date[split_date.length - 1]);
                            let today = moment(new Date());
                            if(d.diff(today, 'days') > 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else if(d.get('date') == moment().get('date')){
                                NotificationManager.error('You cannot set a subject deadline for the current date.');
                            }else{
                                self.setState({confirmSubjectDateModal: true, subjectDate: this.id})
                            }
                            
                        }else{
                            //alert("You clicked on an even1t");
                            let split_date = this.id.split('_');
                            let d = moment(split_date[split_date.length - 1]);
                            let today = moment(new Date());
                            if(today.diff(d, 'days') > 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else if(data.filter(d => d.date == testDate && d.classname != 'day-selected-for-test').length > 0){
                                
                                NotificationManager.error('You would not meet your test date using this course timeline.');    
                                
                                
                                
                            }else if(d.get('date') == moment().get('date')){
                                NotificationManager.error('You cannot set a subject deadline for the current date.');
                            }else{
                                self.setState({subjectDate: this.id})
                            }
                        }
                        return true;
                    },
                    data: data
                });
            }
            
            }
            }
            
            // End cuupdated


        

        if(props.courseUser[0]) {
            if (props.courseUser[0].currentSubjectDeadline && !state.subjectDateConfirmed) {
                this.setState({subjectDateConfirmed: true});
            }
        }

        let nonCharts = ['test'];
        if(state.progressView === '' && props.courseUser.length > 0){
            this.setState({progressView: 'quiz', progressViewLoaded: false}, () => {
                this.buildProgressChart('quiz');
            });
        }
        if(state.progressView !== this.state.progressView && state.progressViewLoaded === false && nonCharts.indexOf(state.progressView) === -1){

            this.buildProgressChart(state.progressView);
        }else if(state.progressView === 'attendance' && this.state.progressView === 'attendance' && state.attendanceType != this.state.attendanceType){

            this.buildProgressChart(state.progressView);
        }
        
        if(state.view !== this.state.view && state.viewLoaded === false && nonCharts.indexOf(state.view) === -1){

            this.buildChart(state.view);
        }else if(state.view === 'attendance' && this.state.view === 'attendance' && state.attendanceType != this.state.attendanceType){

            this.buildChart(state.view);
        }


        if(this.state.attentivePercent === null){
            let attentivePercent = 0;
            if(props.courseUser.length > 0){
                if(this.props.ul){
                    this.props.ul.map((v, i) => {
        
                        try{
                            if(v.videoQuestions.length > 0){
                                attentivePercent += parseInt(v.videoQuestions.filter(q => q.attempts === 1 && q.correct === true).length / v.VideoQuestions.length * 100) || 0;
                            }else{
                                attentivePercent += 100;
                            }
                        }catch(err){

                        }
        
                    })
                }
    
                this.setState({attentivePercent});
            }
        }

        





        if(cuUpdated && state.calendarMode === 'attendance' || state.calendarMode === 'attendance' && state.calendarSet === false){
            this.renderAttendance(props, state);
        }else if(cuUpdated && state.calendarMode === 'subject' || state.calendarMode === 'subject' && state.calendarSet === false){
            this.renderTestDate(props, state);
        }


    }


    }

    setCourseUserTestDate = () => {
        
            $("#" + this.state.testDate).find(".day").addClass("day-selected-for-test");
            let cu = this.props.courseUser[0];
            cu.testDate = new Date(this.state.testDate.split("_")[3] + " 23:59:59");
            let command = {
                type: 'SET_TEST',
                courseUserId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].id,
                testDate: cu.testDate,
                profileId: this.props.courseUser.filter(cu => cu.courseId === this.props.match.params.courseId)[0].profileId
            };
            
            send(command, this.props.socket, this.props.user.id);

            NotificationManager.success("Test date sent.");
            
            //this.props.updateCourseUser(cu, this.props.user.user.profileId, this.props.user.id);
        
        this.setState({confirmTestDateModal: false});
    }

    setCourseUserSubjectDate = () => {
        if(!this.props.courseUser[0].currentSubjectDeadline || moment(this.props.courseUser[0].currentSubjectDeadline).diff(moment(), 'days') < 0) {
            $("#" + this.state.testDate).find(".day").addClass("day-selected-for-test");
            let cu = this.props.courseUser[0];
            cu.currentSubjectDeadline = new Date(this.state.subjectDate.split("_")[this.state.subjectDate.split("_").length - 1] + " 23:59:59");
            cu.currentSubjectStart = new Date();
            this.props.updateCourseUser(cu, this.props.user.user.profileId, this.props.user.id);
            let subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject);
            
            let daysUntilSubjectEnd = moment(cu.currentSubjectDeadline).diff(moment(), 'days');
            /*
            this.props.socket.send(JSON.stringify({
                type: 'ADD_USER_TO_THREAD',
                subjectId: subject[0].id,
                profileId: this.props.user.user.profileId
            }));
            */
            
            let existingThread = this.props.threads.filter(t => t.subjectId === subject[0].id && t.users.indexOf(this.props.user.user.profileId) > -1 && !t.ticket);
             let thread = {
                users: [this.props.user.user.profileId],
                createdAt: new Date(),
                subjectId: subject[0].id,
                status: 1,
                lastActivity: new Date(),
                subjectName: subject[0].name
            }
            
            if(existingThread.length > 0){
                thread.id = existingThread[0].id;   
            }
            
            let command = jwt.sign({
                            command: {
                              type: 'CREATE_THREAD',
                              thread: thread,
                                token: this.props.user.id
                            }}, '#&r7%+UbWU8Hc');
            this.props.socket.send(command)
            
            // Send to socket.
            let data = {
                type: 'CREATE_THREAD',
                thread: thread,
                token: this.props.user.id
            };
            send(data, this.props.socket);
            
            NotificationManager.success("Great! You have " + daysUntilSubjectEnd.toString() + " days to finish " + subject[0].name);
            $('#SetDeadLineModal').modal('hide').removeClass('in');
        }else{
            NotificationManager.error("You've already set a test date.");
        }
        this.setState({confirmSubjectDateModal: false});
    }

    setSubjectDeadline = (id, fromModal) => {
        let hasEvent = $("#" + id).data("hasEvent");
        if (this.props.courseUser[0].currentSubjectDeadline) {
            //alert("You clicked on an event");
            return false;
        }else{
            this.setState({subjectDate: id})
        }
        return true;
    }

    //LifecycleMethods
    componentDidMount() {

        this.props.getLocation();

        if(this.props.profile.onboardingStep < 6 && this.props.user.user.role == "student"){
            this.props.history.push(`/on-boarding`)
        }

        if(this.props.profile.role == "instructor"){
            //this.props.history.push('/dashboard-admin');
        }
        
        this.setState({progressView: 'quiz', progressViewLoaded: false});

        let self = this;

         if(this.props.match.params.profileId && this.props.match.params.courseId && ["instructor", "admin"].indexOf(this.props.user.user.Profile.role) > -1) {
            this.props.onLoad(this.props.match.params.profileId, this.props.match.params.courseId, this.props.user.id);
            this.props.getCourseAndLectures(this.props.match.params.courseId, this.props.user.id);
        }else{
             this.props.onLoad(this.props.user.user.profileId, null, this.props.user.id);
        }

        


    }
    
    componentDidUpdate(props){
        if(this.props.courseUser.length > 0){
            if(this.props.courseUser[0] !== this.state.cu){
                this.setState({cu: this.props.courseUser[0]});
            }
        }
    }
    
    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
          subjectOrder: arrayMove(this.state.subjectOrder, oldIndex, newIndex),
        });
      };

    renderExpandedSubject = (subject) => {
        let behind = false;
        let missedDeadline = false;

        if(subject.id === this.props.courseUser[0].currentSubject &&
            moment(this.props.courseUser[0].currentSubjectDeadline).diff(moment(), 'days') < 0){
            missedDeadline = true;
        }

        return (
            <div className="panel-body">
                {behind &&
                    <div className="alert alert-warning">Hey,<br/>
                        You're going a slower pace than is required to meet your deadline. You need to complete at least <span
                            className="text-underline">{this.state.requiredPerDay} videos per day</span> to meet your goal.
                    </div>
                }

                {missedDeadline &&
                <div className="alert alert-danger">
                    <h1>Dratz! You missed the deadline! </h1>
                    <p className="sm-bottom20">Hey, {this.props.studentProfile.name || this.props.studentProfile.email}!</p>
                    <p className="sm-bottom20">Unfortunately, you did not meet the deadline that you set for yourself to
                        finish {subject.name}. This isn't a good sign and you have make sure that you're working hard to meet
                        them.</p>
                    <p className="sm-bottom20">Please <a href="#SetDeadLineModal" data-toggle="modal"
                                                         className="text-white text-underline"> set a new deadline</a>
                        to finish your goal!</p>
                    #YOUCANDOIT #StayFocused #gameon
                </div>
                }

                {subject.CourseChapter.map((chapter, i) => {
                if(chapter.type !== "test"){
                    return (
                        <div>
                            <h3 className="font-20 text-white">Chapter {i + 1}</h3>
                            <div className="row">
                                {chapter.ChapterVideo.map((v, vi) => {
                                    let part = this.props.ul.filter(p => p.id === v.id);
                                    let finished = false;
                                    let attentiveness, efficiency, quizPercent;
                                    let attentiveClass, quizClass;
                                    let attentivePercent;
                                    if(part.length > 0) {
                                        part = part[0];
                                        finished = true;
                                        attentiveness = 'N/A';
                                        let questions = this.props.videoQuestions.filter(q => q.chapterVideoId === v.id);
                                        if (questions.length > 0) {

                                            attentivePercent = parseInt((questions.filter(q => q.attempts === 1 && q.correct === true).length / questions.length) * 100);
                                            attentiveness = attentivePercent.toString() + '%' || '0%';
                                            attentiveClass = (attentivePercent > 50) ? 'rec-tag-green' : 'rec-tag-orange';

                                        }
                                        
                                        
                                        efficiency = (part.finish) ? parseInt((part.userTime / part.finish) * 100) || 0 : 100;
                                        let quizObject = [];
                                        let quizTotal = 0;
                                        this.props.ul.map((ul, i) => {
                                            if(ul.quiz){
                                                quizObject.push(ul.quiz);
                                                return quizTotal += ul.quiz;
                                            }
                                        })
                                        
                                        quizPercent = Math.ceil((quizTotal / quizObject.length));
                                        
                                    }



                                    return (
                                        <div className="col-xs-12">
                                            <div className="chapter_part_list_item">
                                                <div className="clearfix">
                                                    <p className="pull-left font-16"><i className={`zmdi ${(finished) ? 'zmdi-check-circle text-green' : 'zmdi-circle-o text-info'}`}></i> Part {vi + 1}</p>
                                                    <p className="pull-right font-16"></p>
                                                </div>
                                                <div className="chapter_part_list_item_details">
                                                    <div className="clearfix">
                                                        <div className={`rec-tag ${attentiveClass}`}>
                                                            <span>Attentiveness</span>
                                                            <span>{attentiveness}</span>
                                                        </div>
                                                        <div className={`rec-tag ${quizClass}`}>
                                                            <span>Quiz Score</span>
                                                            <span>{isNaN(quizPercent) ? 0 : quizPercent}</span>
                                                        </div>
                                                        <div className="rec-tag last-rec-tag rec-tag-golden">
                                                            <span>Merits Earned</span>
                                                            <span className="badge">{part.points || 0}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                }

                })}




            </div>
        )
    }



    //Renders
    renderDashboardHeader = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        The Dashboard
                    </h1>
                    <small className="text-muted">
                        Everything Starts Here
                    </small>
                </div>
            </div>
        </div>
    );

    renderActivityPanel = () => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    <i className="zmdi zmdi-run"/>
                    Live Feed
                </h3>
            </div>
            <div className="panel-body sp-10">
                <div className="timeline">
                    {this.renderActivityItem()}
                </div>
            </div>
        </div>
    );

    renderActivityItem = () => (
        this.props.reminders.map((item, index) => (
            <div
                key={index}
                className="timeline-entry"
            >
                <div className="timeline-stat">
                    <div className={`timeline-icon bg-${item.status}`}>
                        <i className={`zmdi zmdi-${item.type}`}/>
                    </div>
                </div>
                <div className="timeline-label">
                    <h3>{item.title}</h3>
                    <p>{item.text} </p>
                    <p>
                        {
                            item.date
                            && <i className="zmdi zmdi-calendar"/>
                        }
                        {item.date}
                    </p>
                </div>
            </div>
        ))
    );

    renderReminders = () => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    <i className="zmdi zmdi-notifications-active"/>
                    Reminders
                </h3>
            </div>
            <div className="panel-body">
                <ul className="reminders">
                    {this.renderReminder()}
                </ul>
            </div>
        </div>
    );

    renderReminder = () => (
        this.props.reminders.map((item, index) => (
            <li key={index}>
                <div className={`alert alert-${item.status}`}>
                    <h3>{item.title}</h3>
                    <p className="due-date">
                        {item.date}
                    </p>
                    <p>
                        {item.text}
                    </p>
                </div>
            </li>
        ))
    );
    
    renderStudyPlan = () => {
    }
    
    handleChange = (selectedOption) => {
        let {task} = this.state;
        task.value = selectedOption;
        this.setState({ task });
      }
    
    render() {

        let {chart} = this.state;
        const {course, ul, us} = this.props;
        let videosLeft = 0;
        let totalVideos = 0;
        let completedVideos = 0;
        let videoTimeLeft = 0;
        
        let flags = [];

        let merits = this.props.courseUser[0] ? this.props.courseUser[0].points : 0;
        
        let cu = this.props.courseUser.filter(c => c.courseId === this.props.match.params.courseId);

        if(cu.length === 0 || !course){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }else{
            cu = cu[0];
            let completedList = [];
            if(this.props.ul){
                completedVideos = this.props.ul.length;
                if(course){
                    if(course.CourseSubject){
                        course.CourseSubject.map(s => {
                            if(s.CourseChapter && s.id === this.props.match.params.subjectId){
                                s.CourseChapter.map(c => {
                                    totalVideos += c.ChapterVideo.length;
                                    
                                    c.ChapterVideo.map(v => {
                                        let completed = this.props.ul.filter(p => p.id === v.id);
                                        if(completedList.indexOf(v.id) === -1 && this.props.ul.filter(uv => uv.chapterVideoId === v.id).length > 0){
                                            completedList.push(v.id);
                                        }
                                        if(this.props.ul.filter(uv => uv.chapterVideoId === v.id).length === 0){
                                            if(completed.length === 0 && v.VideoFile){
                                                if(v.VideoFile.length > 0){
                                                    if(v.VideoFile[v.VideoFile.length - 1].duration){
                                                        videoTimeLeft += v.VideoFile[v.VideoFile.length - 1].duration;
                                                    }
                                                }
                                            }
                                        }
                                    })
                                })
                            }
                        })
                    }
                }
            }
            
            videosLeft = totalVideos - completedList.length;
            videoTimeLeft = moment.duration(videoTimeLeft * 1000);
            
            
            
            if(cu.Flags) {
                flags = JSON.parse(JSON.stringify(cu.Flags)).reverse();
            }
            
            
        }

        
        
        let taskOptions = [];
        if(course){
            if(course.CourseSubject){
                course.CourseSubject.map((s, si) => {
                    if((si === 0 && !this.props.match.params.subjectId) || s.id === this.props.match.params.subjectId && s.CourseChapter){
                        s.CourseChapter.map(c => {
                            if(c.type === "test"){
                                taskOptions.push({value: c.id, label: c.title, test: true});  
                            }else{
                                c.ChapterVideo.map(v => {
                                    taskOptions.push({value: v.id, label: v.title, test:false});
                                    
                                })
                            }
                        })
                    } 
                })
            }
        }
        

        let completionPercent = 0;
        let currentSubject = this.props.us.filter(s => s.courseSubjectId === this.props.match.params.subjectId);
        if(currentSubject.length > 0){
            currentSubject = currentSubject[0];
            if(currentSubject.completedPercent){
                completionPercent = currentSubject.completedPercent;
            }
        }else{
            currentSubject = null;
        }
        

        return (
            <div className="content-wrapper" id="content-container">
            {this.renderNamePage()}


        <section className="content">
            <div className="row">
                <div className="col-sm-8">
                    <div className="nav-tabs-custom no-bg">
                       {this.renderHeaderLinks()}

                        <div className="tab-content no-bg no-padding">
                            
                            <div className="tab-pane active" id="tab_2">
                                <div className="nav-tabs-custom no-bg inner-tabs">
                                    <ul className="nav nav-tabs round-corner-btns">
                                    
                                        {this.renderSubjectTabButtons()}
                                    </ul>
                                    <div className="tab-content no-bg no-padding">
                                        
                                        {this.renderSubjectContent()}

                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="sp-top0">
                        <div className="panel customPanel no-header-margin">
                            <div className="panel-heading bg-light-3">
                                <div className="panel-control status-header">
                                    <PieChart
                                                        style={{width: 40, margin: '0 auto'}}
                                                        data={[
                                                            {value: 100, color: '#555'},
                                                            {value: completionPercent, color: '#e33339'}
                                                        ]}
                                                        totalValue={100}
                                                        startAngle={-90}
                                                        lineWidth={20}
                                                        rounded={true}
                                                    />
                                                    <div className="percentWrapper text-white" style={{lineHeight: "40px", fontSize: "14px"}}>
                                                        <small className="counter text-white" data-from="0" data-to={parseInt(completionPercent)}>{parseInt(completionPercent)}</small>
                                                        <small style={{fontSize: "8px"}}>%</small>
                                                    </div>
                                                  
                                    </div>
                                    <h3 className="panel-title">Status</h3>
                                </div>
                                
                            </div>
                            <div className="panel-body no-padding">
                                <ul className="half-aligned-list">
                                    <li>
                                        <span className="span-left">Official Test Date</span>
                                        <span className="span-right">
                                        {cu.testDate ? moment(cu.testDate).format('MM/DD/YYYY') : 'Not Set'}
                                        
                                        &nbsp;<a href="#TestDateModal" data-toggle="modal"><i className="zmdi zmdi-edit"></i> </a> </span>
                                    </li>
                                    <li>
                                        <span className="span-left">Course Completed</span>
                                        <span className="span-right">{this.renderCourseCompleted()}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Days Remaining</span>
                                        <span className="span-right">{this.state.timeLeft ?
                                            <span>
                                                {parseInt(moment.duration(Math.ceil(this.state.timeLeft*1000)).asDays())}d&nbsp;
                                                {moment.duration(Math.ceil(this.state.timeLeft*1000)).get('hours')}h&nbsp;
                                                {moment.duration(Math.ceil(this.state.timeLeft*1000)).get('minutes')}m&nbsp;
                                                {moment.duration(Math.ceil(this.state.timeLeft*1000)).get('seconds')}s&nbsp;
                                                </span>
                                            : 'N/A'}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Expected Finish Time</span>
                                        <span className="span-right text-success">{this.state.estimatedTime ? moment.utc(this.state.estimatedTime * 1000).format('DD[d] HH[h] mm[m] ss[s]') : 'N/A'}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Videos Remaining</span>
                                        <span className="span-right">{videosLeft}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Total Video Hours Remaining</span>
                                        <span className="span-right text-orange">{videoTimeLeft.hours() + 'h ' + videoTimeLeft.minutes() + 'm ' + videoTimeLeft.seconds() + 's'}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Attentiveness</span>
                                        <span className="span-right">{this.props.courseUser[0] ? Math.ceil(this.props.courseUser[0].attentivePercent) : 0}%</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Quiz Average</span>
                                        <span className="span-right">{this.props.courseUser[0] ? this.props.courseUser[0].quizPercent ? Math.ceil(this.props.courseUser[0].quizPercent) : '-' : 0}%</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="panel customPanel">
                            <div className="panel-heading bg-light-3">
                                <h3 className="panel-title"><i className="fa fa-flag-checkered"></i> Compliance</h3>
                            </div>
                            <div className="panel-body no-padding">
                                <ul className="half-aligned-list">
                                    <li>
                                        <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#e84a5f"}}></i> Red Flags</span>
                                        <span className="span-right"><a href="/red-flags"> {flags.filter(f => f.type === 'red').length}</a></span>
                                    </li>
                                    <li>
                                        <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#ff847c"}}></i> Orange Flags</span>
                                        <span className="span-right"> {flags.filter(f => f.type === 'orange').length}</span>
                                    </li>
                                    <li>
                                        <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#f7d969"}}></i> Yellow Flags</span>
                                        <span className="span-right"> {flags.filter(f => f.type === 'yellow').length}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Recommendations Given</span>
                                        <span className="span-right">-</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Recommendations Followed</span>
                                        <span className="span-right">-</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Notifications</span>
                                        <span className="span-right"><a href="/course-notifications">View</a></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="panel customPanel">
                            <div className="panel-heading bg-light-3">
                                <h3 className="panel-title"><i className="fa fa-lightbulb-o"></i> Weekly Insights</h3>
                            </div>
                            <div className="panel-body no-padding">
                                <ul className="half-aligned-list">
                                    <li>
                                        <span className="span-left">Average Hours Studied</span>
                                        <span className="span-right"> {this.state.studiedAverage}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Days Absent</span>
                                        <span className="span-right">{7 - this.state.studiedThisWeek}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Average Units Completed</span>
                                        <span className="span-right">{this.state.unitsThisWeek}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Attentiveness</span>
                                        <span className="span-right">{this.state.attentiveThisWeek}%</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Quiz Score</span>
                                        <span className="span-right">{this.state.quizScoreThisWeek}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Efficiency</span>
                                        <span className="span-right">{this.state.efficiencyThisWeek}</span>
                                    </li>
                                    <li>
                                        <span className="span-left">Recommendations Followed</span>
                                        <span className="span-right">-</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="sm-bottom30 student-calendar-course-page">
                            <div className="panel customPanel actionsPanel">
                            	<div className="panel-heading bg-light-3">
                                    <div className="panel-control">
                                        <div className="btn btn-group toggleButtons toggle_attendance_calendar_header" style={{position: "static"}}>
                                            <div className="" data-toggle="buttons">
                                                <button className={`btn btn-default ${this.state.calendarMode === 'attendance' ? 'active' : ''}`} onClick={e => this.setState({calendarSet: false, calendarMode: 'attendance'})}>Attendance</button>
                                                <button className={`btn btn-default ${this.state.calendarMode === 'subject' ? 'active' : ''}`} onClick={e => this.setState({calendarSet: false, calendarMode: 'subject'})}>Timeline</button>
                                                
                                                
                                            </div>
                                        </div>

                                    </div>
                                    <h3 className="panel-title">Actions</h3>

                            	</div>
                            	<div className="panel-body no-padding">
                                    <div id="attendance-calendar-wrapper">
                                        <div id="attendance_calendar"></div>
                                    </div></div>
                            </div>


                        </div>
                        <div className="panel customPanel actionsPanel">
                            <div className="panel-heading bg-light-3">
                                <h3 className="panel-title">Actions</h3>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <a href="#SendNotificationModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-notifications"></i> Send Notification</a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="#SendReminderModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-alarm"></i> Recommend Task</a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="#RestrictAccessModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-lock"></i> Restrict Access</a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="#SendAlertModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-alert-triangle"></i> Send Alert</a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="#ChangeLectureOrderModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-refresh"></i> Personalize Course</a>
                                    </div>
                                    <div className="col-md-6">
                                        <a href="#SendDeadlineModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-lock"></i> Set Deadline</a>
                                    </div>
                                    {(this.props.user.user.Profile.role === 'admin' || this.props.user.user.Profile.role === 'instructor') &&
                                        <div className="col-md-6">
                                            <a href="#EditCUModal" data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-account-circle"></i> CP Editor</a>
                                        </div>
                                    }
                                    <div className="col-md-6">
                                        <a href="#resetCourseUserModal" data-toggle="modal" data-target="#resetCourseUserModal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-refresh"></i> Reset</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            

        </section>

        <div className="modal fade in" id="EditLectureModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Lecture Editor</h4>
                        </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group col-md-6">
                                                
                                <label>Active</label>
                                <div className="form-select-overlay">
                                    <select className="form-control" value={this.state.ul.active || true} onChange={e => {
                                        let {ul} = this.state;
                                        ul.active = e.target.value;
                                        this.setState({ul});
                                    }}>
                                        <option value="false">False</option>
                                        <option value="true">True</option>
                                    </select>
                                        
                                        
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                                
                                <label>Completed</label>
                                <div className="form-select-overlay">
                                    <select className="form-control" value={this.state.ul.completed || false} onChange={e => {
                                        let {ul} = this.state;
                                        ul.completed = e.target.value;
                                        this.setState({ul});
                                    }}>
                                        <option value="false">False</option>
                                        <option value="true">True</option>
                                    </select>
                                        
                                        
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group  col-md-4">
                                            
                                <label>Current Video Time (seconds)</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.currentTime || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.currentTime = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>
                            <div className="form-group  col-md-4">
                                            
                                <label>Max Seek Time (seconds)</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.maxTime || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.maxTime = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>

                            <div className="form-group  col-md-4">
                                            
                                <label>Total Time on Lecture</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.userTime || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.userTime = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>


                        </div>
                        <div className="row">
                            <div className="form-group col-md-3">
                                                
                                <label>Attentiveness</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.attentiveness || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.attentiveness = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                                
                                <label>Efficiency</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.efficiency || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.efficiency = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                                
                                <label>Quiz Score</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.quiz || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.quiz = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                                
                                <label>Points Earned</label>
                                <div className="form-select-overlay">
                                    <input type="number" className="form-control" value={this.state.ul.totalPoints || 0} onChange={e => {
                                        let {ul} = this.state;
                                        ul.totalPoints = e.target.value;
                                        this.setState({ul});
                                    }} />
                                        
                                        
                                </div>
                            </div>

                            
                        </div>
                    </div>
                        
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.editLecture()}>Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="EditCUModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        {this.state.cu ?
        this.props.course ?
            this.props.course.CourseSubject ?
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title" id="myModalLabel">CP Editor</h4>
                            </div>
                            <div className="modal-body no-padding">
                                <div className="modal-body">
                                    <p className="text-danger">Warning: CP Editor will directly edit the students course progress.  Use with care.</p>
                                    <br />
                                    {this.state.cu &&
                                        <div>
                                        <div className="row">
                                            <div className="form-group col-md-4">
                                            
                                                <label>Current Subject</label>
                                                <div className="form-select-overlay">
                                                    <select className="form-control" value={this.state.cu ? this.state.cu.currentSubject : ''} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.currentSubject = e.target.value;
                                                        this.setState({cu});
                                                    }}>
                                                        {this.state.cu ?
                                                        this.props.course ?
                                                            this.props.course.CourseSubject ?
                                                            this.props.course.CourseSubject.map((s, i) => {
                                                                return <option key={i} value={s.id}>{i + 1}. {s.name}</option>
                                                            })
                                                            : null
                                                        : null
                                                            : null
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            {this.props.course ?
                                            this.props.course.CourseSubject ?
                                            this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject).length > 0 ?
                                            <div className="form-group  col-md-4">
                                            
                                                <label>Current Chapter</label>
                                                <div className="form-select-overlay">
                                                    <select className="form-control" value={this.state.cu ? this.state.cu.currentChapter  ? this.state.cu.currentChapter : '' : ''} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.currentChapter = e.target.value;
                                                        this.setState({cu});
                                                    }}>
                                                        <option value=''>Select</option>
                                                        {this.state.cu ?
                                                            this.props.course.CourseSubject ? 
                                                            this.props.course.CourseSubject[0].CourseChapter ?
                                                            this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject)[0].CourseChapter.sort(function(a,b) {
                                                                return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                                            } ).map((s, i) => {
                                                                if(s.type == "test"){
                                                                    return <option key={i} value={s.id}>{i + 1}. {s.title}</option>
                                                                }else{
                                                                    return <option key={i} value={s.id}>{i + 1}. {s.name}</option>
                                                                }
                                                            })
                                                            : null
                                                        : null
                                                        : null
                                                            
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            : null
                                        : null
                                    : null }
                                            
                                            {this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject).length > 0 ?
                                            this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject)[0].CourseChapter ?
                                            this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject)[0].CourseChapter.filter(ch => ch.id === this.state.cu.currentChapter).length > 0 ?
                                            <div className="form-group col-md-4">
                                            
                                                <label>Current Part</label>
                                                <div className="form-select-overlay">
                                                    <select className="form-control" value={this.state.cu ? this.state.cu.currentChapterPart : ''} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.currentChapterPart = e.target.value;
                                                        this.setState({cu});
                                                    }}>
                                                        <option value=''>Select</option>
                                                        {this.state.cu ?
                                                        this.props.course.CourseSubject ?
                                                        this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject)[0].CourseChapter ?
                                                            this.props.course.CourseSubject.filter(cs => cs.id === this.state.cu.currentSubject)[0].CourseChapter.filter(ch => ch.id === this.state.cu.currentChapter)[0].ChapterVideo.sort(function(a,b) {
                                                                return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                                            } ).map((s, i) => {
                                                                return <option key={i} value={s.id}>{i + 1}. {s.title || s.name} {s.status === false || s.status === "false" ? '(INACTIVE)' : ''}</option>
                                                            })
                                                        : null
                                                        : null
                                                        : null
                                                            
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            : null
                                            : null
                                            : null }
                                            </div>
                                            <div className="row">
                                            <br />
                                            <div className="col-md-12"><p className="text-success">The following fields are not related to the users current position in their course. (Relatively safe)</p></div>
                                            <div className="form-group col-md-6">
                                            
                                                <label>Should Update (Rebuild charts)</label>
                                                <div className="form-select-overlay">
                                                    <select className="form-control" value={this.state.cu ? this.state.cu.shouldUpdate : false} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.shouldUpdate = e.target.value;
                                                        this.setState({cu});
                                                    }}>
                                                        
                                                        <option value="false">False</option>
                                                        <option value="true">True</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group  col-md-6">
                                            
                                                <label>Points (the users total points)</label>
                                                <div className="form-select-overlay">
                                                    <input type="number" className="form-control" value={this.state.cu ? this.state.cu.points : 0} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.points = e.target.value;
                                                        this.setState({cu});
                                                    }} />
                                                        
                                                        
                                                </div>
                                            </div>

                                            <div className="form-group  col-md-4">
                                            
                                                <label>Course Attempt (number)</label>
                                                <div className="form-select-overlay">
                                                    <input type="number" className="form-control" value={this.state.cu ? this.state.cu.courseAttempt : 0} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.courseAttempt = e.target.value;
                                                        this.setState({cu});
                                                    }} />
                                                        
                                                        
                                                </div>
                                            </div>

                                            <div className="form-group col-md-4">
                                            
                                                <label>Subject Attempt (number)</label>
                                                <div className="form-select-overlay">
                                                    <input type="number" className="form-control" value={this.state.cu ? this.state.cu.subjectAttempt : 0} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.subjectAttempt = e.target.value;
                                                        this.setState({cu});
                                                    }} />
                                                        
                                                        
                                                </div>
                                            </div>

                                            <div className="form-group col-md-4">
                                            
                                                <label>Status</label>
                                                <div className="form-select-overlay">
                                                    <select className="form-control" value={this.state.cu ? this.state.cu.status : 'pending'} onChange={e => {
                                                        let {cu} = this.state;
                                                        cu.status = e.target.value;
                                                        this.setState({cu});
                                                    }}>
                                                        
                                                        <option value="pending">Pending</option>
                                                        <option value="blocked">Blocked</option>
                                                        <option value="approved">Approved</option>
                                                    </select>
                                                        
                                                </div>
                                            </div>
                                        
                                        </div>
                                        <div>
                                            
                                            
                                            
                                            </div>
                                            </div>
                                    }
                        
                        </div>
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.editCU()}>Save Changes</button>
                        </div>
                    </div>
                </div>
            : null
            : null
            : null
        }
            
        </div>
        
        
        <div className="modal fade in" id="SendDeadlineModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Send Notification</h4>
                        </div>
                        <div className="modal-body no-padding">
                            <div className="modal-body">
                        <div className="form-group">
                            
                            <label>Date:</label>
                            <DatePicker
                                selected={moment(this.state.deadline)}
                                onChange={(e) => {
                                    let {deadline} = this.state;
                                    deadline = e;
                                    this.setState({deadline});
                                }}
                                className="form-control"
                            />
                                       
                        </div>
                        <div className="form-group">
                            <label>Details</label>
                            <textarea className="form-control" rows="5" style={{height: "200px"}} value={this.state.sendNotification.content} onChange={e => {
                                let {sendNotification} = this.state;
                                sendNotification.content = e.target.value;
                                this.setState({sendNotification}); 
                            }}></textarea>
                        </div>
                       
                    </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.sendDeadline()}>Set Deadline</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="SendNotificationModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Send Notification</h4>
                        </div>
                        <div className="modal-body no-padding">
                            <div className="modal-body">
                        <div className="form-group">
                            <label>Subject</label>
                            <input type="text" className="form-control" value={this.state.sendNotification.subjectId} onChange={e => {
                                let {sendNotification} = this.state;
                                sendNotification.subjectId = e.target.value;
                                this.setState({sendNotification}); 
                            }} />
                        </div>
                        <div className="form-group">
                            <label>Message</label>
                            <textarea className="form-control" rows="5" style={{height: "200px"}} value={this.state.sendNotification.content} onChange={e => {
                                let {sendNotification} = this.state;
                                sendNotification.content = e.target.value;
                                this.setState({sendNotification}); 
                            }}></textarea>
                        </div>
                        <div className="form-group">
                            <label>Sender</label>
                            <select className="form-control" value={this.state.sendNotification.sender} onChange={e => {
                                let {sendNotification} = this.state;
                                sendNotification.sender = e.target.value;
                                this.setState({sendNotification}); 
                            }}>
                                <option value="admin">Admin</option>
                                <option value="Support">Support</option>
                                <option value="Instructor">Instructor</option>
                            </select>
                        </div>
                    </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.sendNotification()}>Send Notification</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="SendAlertModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Send Alert</h4>
                        </div>
                        <div className="modal-body no-padding">
                            <div className="modal-body">
                        
                        
                            <div className="form-group">
                                <label>Type</label>
                                <select className="form-control" value={this.state.flag.type} onChange={e => {
                                    let {flag} = this.state;
                                    flag.type = e.target.value;
                                    this.setState({flag}); 
                                }}>
                                    <option value="red">Red Flag</option>
                                    <option value="orange">Orange Flag</option>
                                    <option value="yellow">Yellow Flag</option>
                                </select>
                            </div>
                            <br />
                            <div className="form-group">
                            <label>Message</label>
                            <textarea className="form-control" rows="5" style={{height: "200px"}} value={this.state.flag.content} onChange={e => {
                                let {flag} = this.state;
                                flag.content = e.target.value;
                                this.setState({flag}); 
                            }}></textarea>
                        </div>
                        </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.sendFlag()}>Send Alert</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="TestDateModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Set Test Date</h4>
                    </div>
                    <div className="modal-body">
                        <div className="deadline_calendar no-margin">
                                                                <div className="calendar_1">
                                                                    <div id="test_calendar"/>
                                                                </div>
                                                                </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="SendReminderModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Recommend Task</h4>
                    </div>
                    <div className="modal-body">
                    <div className="row">
                        
                       
                                                
                        <div className="col-md-12">
                            <input className="form-control" placeholder="Task Title" value={this.state.task.title} onChange={e => {
                                let {task} = this.state;
                                task.title = e.target.value;
                                this.setState({task});
                            }} />
                            <br />
                        </div>
                        <div className="col-md-12">
                        <Select
                            value={this.state.task.value}
                            onChange={this.handleChange}
                            isMulti={true}
                            options={taskOptions}
                          />
                          </div>
                        </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" onClick={e => this.sendTask()} data-dismiss="modal">Send Recommendation</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="RestrictAccessModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Restrict Access</h4>
                    </div>
                    <div className="modal-body">
                        
                         <ul className="list-unstyled mcqList">
                             <li>
                                <label>
                                    <div
                                        className={`iradio_square video-modal-radio-wrapper ${this.state.courseStatus.type === "indefinitely" && 'checked'}`}
                                    >
                                        <input
                                            type="radio"
                                            name="radio"
                                            value="indefinitely"
                                            className='video-modal-radio'
                                            onClick={(e)=> {
                                                let {courseStatus} = this.state;
                                                courseStatus.type = 'indefinitely';
                                                courseStatus.start = '';
                                                courseStatus.end = '';
                                                this.setState({courseStatus});
                                            }}
                                        />
                                        <ins className="iCheck-helper video-modal-radio-icon"/>
                                    </div>
                                    Indefinitely
                                </label>
                            </li>
                            <li>
                                <label>
                                    <div
                                        className={`iradio_square video-modal-radio-wrapper ${this.state.courseStatus.type === "date" && 'checked'}`}
                                    >
                                        <input
                                            type="radio"
                                            name="radio"
                                            value="date"
                                            className='video-modal-radio'
                                            onClick={(e)=> {
                                                let {courseStatus} = this.state;
                                                courseStatus.type = 'date';
                                                this.setState({courseStatus});
                                            }}
                                        />
                                        <ins className="iCheck-helper video-modal-radio-icon"/>
                                    </div>
                                    Limited Days
                                </label>
                                {this.state.courseStatus.type === 'date' &&
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label>From:</label>
                                            <DatePicker
                                                selected={this.state.courseStatus.start ? moment(this.state.courseStatus.start) : ''}
                                                onChange={(e) => {
                                                    let {courseStatus} = this.state;
                                                    courseStatus.start = e;
                                                    this.setState({courseStatus});
                                                }}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>To:</label>
                                            <DatePicker
                                                selected={this.state.courseStatus.end ? moment(this.state.courseStatus.end) : ''}
                                                onChange={(e) => {
                                                    let {courseStatus} = this.state;
                                                    courseStatus.end = e;
                                                    this.setState({courseStatus});
                                                }}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                }
                            </li>
                            <li>
                                <label>
                                    <div
                                        className={`iradio_square video-modal-radio-wrapper ${this.state.courseStatus.type === "remove" && 'checked'}`}
                                    >
                                        <input
                                            type="radio"
                                            name="radio"
                                            value="remove"
                                            className='video-modal-radio'
                                            onClick={(e)=> {
                                                let {courseStatus} = this.state;
                                                courseStatus.type = 'remove';
                                                courseStatus.start = '';
                                                courseStatus.end = '';
                                                this.setState({courseStatus});
                                            }}
                                        />
                                        <ins className="iCheck-helper video-modal-radio-icon"/>
                                    </div>
                                    Remove Access
                                </label>
                            </li>
                        </ul>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.sendRestriction()}>Apply Restriction</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade in" id="ChangeLectureOrderModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title" id="myModalLabel">Change Lecture Order</h4>
                    </div>
                    <div className="modal-body no-padding">
                        <div id="subject_chapters_list" className="ui-sortable">
                           <SortableList
                                subjects={this.state.subjectOrder}
                                onSortEnd={this.onSortEnd}
                                course={this.props.course}
                            />
                        </div>
                        
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.setSubjectOrder()}>Save changes</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="bootbox modal fade bootbox-confirm" id="resetCourseUserModal" tabIndex="-1" role="dialog" >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="bootbox-close-button close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 className="modal-title">Confirm Reset!</h4>
                    </div>
                    <div className="modal-body">
                        <div className="bootbox-body">Are you sure that you want to delete all progress, and start the student's course from scratch?
                        <br /><br />
                        This will remove all existing data and will prompt another diagnostic test. 
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button data-dismiss="modal" type="button" className="btn btn-default w-100">No</button>
                        <button onClick={e => this.resetCourseUser()} type="button" className="btn btn-base w-100">Yes</button>
                    </div>
                </div>
            </div>
        </div>
        
        {this.state.confirmTestDateModal &&
            <ConfirmationModal
                title="Confirm Official Test Date!"
                text="Are you sure you want to choose this date as your official test date?"
                cancel={() => this.setState({confirmTestDateModal: false})}
                confirm={() => this.setCourseUserTestDate()}
            />
        }
        
        <div className="modal fade" id="CourseAnalyticsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-body no-padding">
                    <table id="datatable" className="hidden">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Physics</th>
                            <th>Chemistry</th>
                            <th>Math</th>
                            <th>Bio</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>Physics</th>
                            <td>2</td>
                            <td>10</td>
                            <td>3</td>
                            <td>10</td>
                            <td>7</td>
                            <td>7</td>
                            <td>4</td>
                            <td>5</td>
                            <td>6</td>
                        </tr>
                        <tr>
                            <th>Chemistry</th>
                            <td>7</td>
                            <td>1</td>
                            <td>10</td>
                            <td>1</td>
                            <td>2</td>
                            <td>1</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <th>Math</th>
                            <td>5</td>
                            <td>8</td>
                            <td>2</td>
                            <td>7</td>
                            <td>1</td>
                            <td>3</td>
                            <td>3</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <th>Bio</th>
                            <td>3</td>
                            <td>3</td>
                            <td>5</td>
                            <td>6</td>
                            <td>5</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="sp-20 flex space-between align-center">
                        <h1 className="font-300 sm-bottom10">{course.name} Analytics 
                        
                            <span id="GraphTitle"> | &nbsp;
                            {this.state.view === 'subject' &&
                                <span>Subject Performance</span>
                            }
                            
                            {this.state.view === 'quiz' &&
                                <span>Quiz Performance</span>
                            }
                            
                            {this.state.view === 'attendance' &&
                                <span>Attendance</span>
                            }
                            
                            {this.state.view === 'attentiveness' &&
                                <span>Attentiveness</span>
                            }
                            
                            {this.state.view === 'efficiency' &&
                                <span>Efficiency</span>
                            }
                            
                            {this.state.view === 'completion' &&
                                <span>Completion</span>
                            }
                            </span>
                        </h1>

                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="sp-left20">
                                <div className="sm-bottom30">
                                {/*
                                    <a href="#" id="SubjectPerformanceButton" className="btn btn-filter btn-default active-btn-filter btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'subject'){
                                                            this.setState({view: 'subject', viewLoaded: false});
                                                        }
                                                    }}>Subject Performance</a>
                                                */}
                                    <a href="#" className="btn btn-filter btn-default btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'quiz'){
                                                            this.setState({view: 'quiz', viewLoaded: false});
                                                        }
                                                    }}>Quiz Performance</a>
                                </div>
                                <a href="#" className="btn btn-filter btn-default btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'attendance'){
                                                            this.setState({view: 'attendance', viewLoaded: false});
                                                        }
                                                    }}>Attendance</a>
                                <a href="#" className="btn btn-filter btn-default btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'attentiveness'){
                                                            this.setState({view: 'attentiveness', viewLoaded: false});
                                                        }
                                                    }}>Attentiveness</a>
                                <a href="#" className="btn btn-filter btn-default btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'efficiency'){
                                                            this.setState({view: 'efficiency', viewLoaded: false});
                                                        }
                                                    }}>Efficiency</a>
                                <a href="#" className="btn btn-filter btn-default btn-block" onClick={(e) => {
                                                        e.preventDefault();
                                                        if(this.state.view !== 'completion'){
                                                            this.setState({view: 'completion', viewLoaded: false});
                                                        }
                                                    }}>Completion</a>

                            </div>
                        </div>
                        <div className="col-sm-9">
                            <div className="relative">
                                <div id="AvgScore no-padding pt-0" style={{minWidth: "310px", height: "400px", margin: "0 auto", paddingTop: "0px !important"}}>
                                {this.state.viewLoaded &&
                                    <div>
                                        
                                         <ReactHighcharts
                                            config={this.renderConfigHighchart(this.state.chart)}
                                            isPureConfig={true}
                                            neverReflow={true}
                                            ref="chart"
                                        />
                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    {
        this.renderQuizResults()
    }
    {
        this.renderTestResults()
    }
    {this.renderQuestionResults()}
    </div>
        )
    }

    
}

StudentProgress.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string.isRequired,
        surname: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
        rank: PropTypes.number.isRequired,
        commonProgress: PropTypes.number.isRequired,
        message: PropTypes.string.isRequired,
        courseList: PropTypes.array.isRequired
    })
};

export default StudentProgress;


// WEBPACK FOOTER //
// ./src/components/StudentProfile/StudentProgress.js